export * from '../models/AggregationServingToken.js';
export * from '../models/AggregationServingTokenSortField.js';
export * from '../models/AlertChannel.js';
export * from '../models/AlertChannelKind.js';
export * from '../models/AnalyzeSqlQueryRequest.js';
export * from '../models/AvailableRepository.js';
export * from '../models/AwsCredentialProfile.js';
export * from '../models/AwsCredentialProfileInput.js';
export * from '../models/AwsLoggingSettings.js';
export * from '../models/AwsLoggingSettingsInput.js';
export * from '../models/AwsMetricsSettings.js';
export * from '../models/AwsMetricsSettingsInput.js';
export * from '../models/AwsNetworkingSettings.js';
export * from '../models/AwsNetworkingSettingsVpcPeering.js';
export * from '../models/AwsPrincipal.js';
export * from '../models/AwsPrincipalInput.js';
export * from '../models/AwsPrivateLink.js';
export * from '../models/AwsSecretsManagerRef.js';
export * from '../models/AwsSecretsManagerRefInput.js';
export * from '../models/AwsStorageAccessConfigurationInput.js';
export * from '../models/AwsVpcPeering.js';
export * from '../models/AwsWorkspaceInfo.js';
export * from '../models/BatchDraftCommitInput.js';
export * from '../models/BatchGetAggregationRowsRequest.js';
export * from '../models/BatchGetAggregationRowsResponse.js';
export * from '../models/BatchIngestionPipelineMetricsRangeRequest.js';
export * from '../models/BatchIngestionPipelineMetricsRangeResponse.js';
export * from '../models/BatchIngestionPipelineMetricsRequest.js';
export * from '../models/BatchIngestionPipelineMetricsResponse.js';
export * from '../models/BatchMode.js';
export * from '../models/BiglakeCatalogMode.js';
export * from '../models/BiglakeCatalogProperties.js';
export * from '../models/BooleanFilters.js';
export * from '../models/BucketFileCompression.js';
export * from '../models/BucketFileFormat.js';
export * from '../models/BucketFileProbeRequest.js';
export * from '../models/BucketFileProbeResponse.js';
export * from '../models/BucketFilesMode.js';
export * from '../models/BucketFilesSourceProperties.js';
export * from '../models/BucketNotificationProbeRequest.js';
export * from '../models/BucketNotificationProbeResponse.js';
export * from '../models/BucketNotificationTransport.js';
export * from '../models/BucketPathPartitionSpec.js';
export * from '../models/CatalogAccessRequest.js';
export * from '../models/CatalogAccessResponse.js';
export * from '../models/CatalogCheckNameRequest.js';
export * from '../models/CatalogCheckNameResponse.js';
export * from '../models/CatalogDatabase.js';
export * from '../models/CatalogListDatabasesRequest.js';
export * from '../models/CatalogListDatabasesResponse.js';
export * from '../models/CatalogOwner.js';
export * from '../models/CategoryTrendSeries.js';
export * from '../models/ChangeOp.js';
export * from '../models/CloudPrincipal.js';
export * from '../models/CloudPrincipalAws.js';
export * from '../models/CloudPrincipalGcp.js';
export * from '../models/CloudPrincipalInput.js';
export * from '../models/CloudPrincipalInputAws.js';
export * from '../models/CloudPrincipalInputGcp.js';
export * from '../models/ColumnNullRate.js';
export * from '../models/ColumnRole.js';
export * from '../models/CommitChangeInput.js';
export * from '../models/CommitterCommand.js';
export * from '../models/CommitterCompactionStrategyStats.js';
export * from '../models/CommitterMaintenanceStats.js';
export * from '../models/CommitterSealCompactionStats.js';
export * from '../models/CompactionStrategy.js';
export * from '../models/CompleteGitIntegrationInput.js';
export * from '../models/Condition.js';
export * from '../models/ConnectGitRepositoryInput.js';
export * from '../models/CreateAggregationServingTokenRequest.js';
export * from '../models/CreateAggregationServingTokenResponse.js';
export * from '../models/CreateAwsPrivateLinkInput.js';
export * from '../models/CreateAwsVpcPeeringInput.js';
export * from '../models/CreateCredentialsProfileInput.js';
export * from '../models/CreateDashboardInput.js';
export * from '../models/CreateDataCatalogInput.js';
export * from '../models/CreateDataCatalogInputGlueProperties.js';
export * from '../models/CreateDataCatalogInputIcebergRestProperties.js';
export * from '../models/CreateGcpVpcPeeringInput.js';
export * from '../models/CreateGraphInput.js';
export * from '../models/CreateIngestionPipelineInput.js';
export * from '../models/CreateJobTemplateInput.js';
export * from '../models/CreateNotebookInput.js';
export * from '../models/CreatePscEndpointInput.js';
export * from '../models/CreatePullRequestInput.js';
export * from '../models/CreateSavedQueryInput.js';
export * from '../models/CreateSparkEngineInput.js';
export * from '../models/CreateSqlEngineInput.js';
export * from '../models/CreateZeroEtlPolicyInput.js';
export * from '../models/CredentialsProbeAssumeResponse.js';
export * from '../models/CredentialsProbeWriteResponse.js';
export * from '../models/CredentialsProfile.js';
export * from '../models/CredentialsProfileAws.js';
export * from '../models/CredentialsProfileGcp.js';
export * from '../models/CredentialsProfileSortField.js';
export * from '../models/CriticalColumnSlo.js';
export * from '../models/CsvOptions.js';
export * from '../models/Dashboard.js';
export * from '../models/DashboardGraph.js';
export * from '../models/DashboardGraphLayout.js';
export * from '../models/DashboardSortField.js';
export * from '../models/DashboardWithGraphs.js';
export * from '../models/DataCatalog.js';
export * from '../models/DataCatalogBiglakeProperties.js';
export * from '../models/DataCatalogGlueProperties.js';
export * from '../models/DataCatalogIcebergRestProperties.js';
export * from '../models/DataCatalogSortField.js';
export * from '../models/DataCatalogType.js';
export * from '../models/DataCatalogTypeFilters.js';
export * from '../models/DataQualityAlertRouting.js';
export * from '../models/DataQualityDashboard.js';
export * from '../models/DataQualityDashboardSection.js';
export * from '../models/DataQualityHeadlineKpi.js';
export * from '../models/DataQualityHealthTrendSignal.js';
export * from '../models/DataQualityNavStatus.js';
export * from '../models/DataQualityTableMeta.js';
export * from '../models/DateRangeFilter.js';
export * from '../models/DetectedFormat.js';
export * from '../models/DetectedFormatType.js';
export * from '../models/DiffChangeType.js';
export * from '../models/DistributionBucket.js';
export * from '../models/DistributionColumn.js';
export * from '../models/DistributionKind.js';
export * from '../models/DistributionTrend.js';
export * from '../models/DistributionTrendDistinct.js';
export * from '../models/EnumCategoryShare.js';
export * from '../models/EnumDistribution.js';
export * from '../models/EonSparkVersion.js';
export * from '../models/ErrorPolicy.js';
export * from '../models/ExecuteNotebookCodeInput.js';
export * from '../models/FieldConfig.js';
export * from '../models/FieldOverride.js';
export * from '../models/FieldOverrideOnError.js';
export * from '../models/FieldOverrideTargetType.js';
export * from '../models/FileFormat.js';
export * from '../models/FileReadOnlyReason.js';
export * from '../models/FlinkDeploymentObservation.js';
export * from '../models/GaussianFit.js';
export * from '../models/GcpCredentialProfile.js';
export * from '../models/GcpCredentialProfileInput.js';
export * from '../models/GcpLoggingSettings.js';
export * from '../models/GcpLoggingSettingsInput.js';
export * from '../models/GcpMetricsSettings.js';
export * from '../models/GcpMetricsSettingsInput.js';
export * from '../models/GcpNetworkingSettings.js';
export * from '../models/GcpNetworkingSettingsVpcPeering.js';
export * from '../models/GcpPrincipal.js';
export * from '../models/GcpPrincipalInput.js';
export * from '../models/GcpSecretManagerRef.js';
export * from '../models/GcpSecretManagerRefInput.js';
export * from '../models/GcpStorageAccessConfigurationInput.js';
export * from '../models/GcpVpcPeering.js';
export * from '../models/GcpWorkspaceInfo.js';
export * from '../models/GcsListPrefixesRequest.js';
export * from '../models/GcsListPrefixesResponse.js';
export * from '../models/GcsSampleObject.js';
export * from '../models/GcsSourceProperties.js';
export * from '../models/GetIngestionPipelineErrorsResponse.js';
export * from '../models/GetIngestionPipelineSchemaResponse.js';
export * from '../models/GetIngestionPipelineSpendLedgerResponse.js';
export * from '../models/GetNotebookContent200Response.js';
export * from '../models/GetStreamCursorHaltsResponse.js';
export * from '../models/GetTableContextFileResponse.js';
export * from '../models/GetTableContextResponse.js';
export * from '../models/GetTableContextRewriteResponse.js';
export * from '../models/GetTableDataQualityColumnInspectResponse.js';
export * from '../models/GetTableDataQualityCompletenessResponse.js';
export * from '../models/GetTableDataQualityDistributionColumnResponse.js';
export * from '../models/GetTableDataQualityDistributionResponse.js';
export * from '../models/GetTableDataQualityEventTimeHistogramResponse.js';
export * from '../models/GetTableDataQualityHeaderResponse.js';
export * from '../models/GetTableDataQualityHealthTrendResponse.js';
export * from '../models/GetTableDataQualityOverviewResponse.js';
export * from '../models/GetTableDataQualityPartitionsResponse.js';
export * from '../models/GetTableDataQualityProfileResponse.js';
export * from '../models/GetTableDataQualityQuarantineBatchResponse.js';
export * from '../models/GetTableDataQualityQuarantineResponse.js';
export * from '../models/GetTableDataQualitySchemaChangesResponse.js';
export * from '../models/GetTableDataQualitySettingsResponse.js';
export * from '../models/GetTableDataQualityWidgetSeriesResponse.js';
export * from '../models/GetTableSampleResponse.js';
export * from '../models/GetTableSignalsResponse.js';
export * from '../models/GetTableSnapshotsResponse.js';
export * from '../models/GitAccountType.js';
export * from '../models/GitCommitResult.js';
export * from '../models/GitDiffEntry.js';
export * from '../models/GitDiffResponse.js';
export * from '../models/GitDraft.js';
export * from '../models/GitDraftPullRequest.js';
export * from '../models/GitFileResponse.js';
export * from '../models/GitIntegration.js';
export * from '../models/GitIntegrationStatus.js';
export * from '../models/GitMergeResult.js';
export * from '../models/GitProvider.js';
export * from '../models/GitProviderFilters.js';
export * from '../models/GitPullRequest.js';
export * from '../models/GitRepository.js';
export * from '../models/GitRepositorySortField.js';
export * from '../models/GitRepositoryStatus.js';
export * from '../models/GitRepositoryStatusFilters.js';
export * from '../models/GitTreeEntry.js';
export * from '../models/GitTreeResponse.js';
export * from '../models/GlueCatalogProperties.js';
export * from '../models/GlueCatalogPropertiesInput.js';
export * from '../models/GraphSortField.js';
export * from '../models/HealthStatus.js';
export * from '../models/IcebergCompactionConfig.js';
export * from '../models/IcebergRestCatalogAuthType.js';
export * from '../models/IcebergRestCatalogProperties.js';
export * from '../models/IcebergRestCatalogPropertiesCredentialsSecret.js';
export * from '../models/IcebergRestCatalogPropertiesInput.js';
export * from '../models/IcebergRestCatalogPropertiesInputCredentialsSecret.js';
export * from '../models/IcebergSinkProperties.js';
export * from '../models/IcebergSnapshotEntry.js';
export * from '../models/IcebergTableColumn.js';
export * from '../models/IdFilters.js';
export * from '../models/IngestionComputeSize.js';
export * from '../models/IngestionPartition.js';
export * from '../models/IngestionPartitionSortField.js';
export * from '../models/IngestionPartitionStatus.js';
export * from '../models/IngestionPartitionStatusFilters.js';
export * from '../models/IngestionPipeline.js';
export * from '../models/IngestionPipelineAggregationMetrics.js';
export * from '../models/IngestionPipelineDeadLetter.js';
export * from '../models/IngestionPipelineDeadLetterByteRange.js';
export * from '../models/IngestionPipelineDeadLetterErrorGroup.js';
export * from '../models/IngestionPipelineDeadLetterSortField.js';
export * from '../models/IngestionPipelineDeadLetterSummary.js';
export * from '../models/IngestionPipelineErrorClass.js';
export * from '../models/IngestionPipelineErrorLevel.js';
export * from '../models/IngestionPipelineErrorSource.js';
export * from '../models/IngestionPipelineHealth.js';
export * from '../models/IngestionPipelineIssue.js';
export * from '../models/IngestionPipelineIssueSeverity.js';
export * from '../models/IngestionPipelineLastObservation.js';
export * from '../models/IngestionPipelineMetrics.js';
export * from '../models/IngestionPipelineMetricsRange.js';
export * from '../models/IngestionPipelineObservation.js';
export * from '../models/IngestionPipelineObservationFlinkDeployment.js';
export * from '../models/IngestionPipelinePurgeMetrics.js';
export * from '../models/IngestionPipelineRetiredAggregation.js';
export * from '../models/IngestionPipelineRetiredAggregationPhase.js';
export * from '../models/IngestionPipelineSortField.js';
export * from '../models/IngestionPipelineSpendLedgerRow.js';
export * from '../models/IngestionPipelineStatus.js';
export * from '../models/IngestionPipelineStatusFilters.js';
export * from '../models/IngestionPipelineTag.js';
export * from '../models/IngestionRuntime.js';
export * from '../models/IngestionSinkType.js';
export * from '../models/IngestionSourceType.js';
export * from '../models/JobTemplate.js';
export * from '../models/JobTemplateRetryPolicy.js';
export * from '../models/JobTemplateSchedule.js';
export * from '../models/JobTemplateScheduleInput.js';
export * from '../models/JobTemplateSortField.js';
export * from '../models/JsonPathSample.js';
export * from '../models/K8sEventObservation.js';
export * from '../models/KafkaBatchConfig.js';
export * from '../models/KafkaConnectProbeRequest.js';
export * from '../models/KafkaConnectProbeResponse.js';
export * from '../models/KafkaErrorHandlingConfig.js';
export * from '../models/KafkaInferSchemaRequest.js';
export * from '../models/KafkaInferSchemaResponse.js';
export * from '../models/KafkaKeyHandling.js';
export * from '../models/KafkaMessageFormat.js';
export * from '../models/KafkaMessageSample.js';
export * from '../models/KafkaOffsetStrategy.js';
export * from '../models/KafkaPartitioningConfig.js';
export * from '../models/KafkaSampleProbeRequest.js';
export * from '../models/KafkaSampleProbeResponse.js';
export * from '../models/KafkaSaslMechanism.js';
export * from '../models/KafkaSchemaOverridesConfig.js';
export * from '../models/KafkaSecretProbeRequest.js';
export * from '../models/KafkaSecretProbeResponse.js';
export * from '../models/KafkaSecurityConfig.js';
export * from '../models/KafkaSecurityConfigCredentialsSecret.js';
export * from '../models/KafkaSecurityConfigInput.js';
export * from '../models/KafkaSecurityConfigInputCredentialsSecret.js';
export * from '../models/KafkaSecurityConfigInputTlsSecret.js';
export * from '../models/KafkaSecurityConfigTlsSecret.js';
export * from '../models/KafkaSecurityProtocol.js';
export * from '../models/KafkaSourceConfig.js';
export * from '../models/KafkaSourceProperties.js';
export * from '../models/KafkaSourcePropertiesInput.js';
export * from '../models/KafkaStartingOffset.js';
export * from '../models/KafkaTopicInfo.js';
export * from '../models/KafkaTopicPartition.js';
export * from '../models/KafkaTopicsProbeRequest.js';
export * from '../models/KafkaTopicsProbeResponse.js';
export * from '../models/ListAggregationServingTokensFilterConditions.js';
export * from '../models/ListAggregationServingTokensRequest.js';
export * from '../models/ListAggregationServingTokensResponse.js';
export * from '../models/ListAvailableRepositoriesResponse.js';
export * from '../models/ListCredentialsProfilesFilterConditions.js';
export * from '../models/ListCredentialsProfilesRequest.js';
export * from '../models/ListCredentialsProfilesResponse.js';
export * from '../models/ListDashboardsFilterConditions.js';
export * from '../models/ListDashboardsRequest.js';
export * from '../models/ListDashboardsResponse.js';
export * from '../models/ListDataCatalogsFilterConditions.js';
export * from '../models/ListDataCatalogsRequest.js';
export * from '../models/ListDataCatalogsResponse.js';
export * from '../models/ListGitIntegrationsResponse.js';
export * from '../models/ListGitRepositoriesFilterConditions.js';
export * from '../models/ListGitRepositoriesRequest.js';
export * from '../models/ListGitRepositoriesResponse.js';
export * from '../models/ListGraphsFilterConditions.js';
export * from '../models/ListGraphsRequest.js';
export * from '../models/ListGraphsResponse.js';
export * from '../models/ListIngestionPipelineDeadLettersRequest.js';
export * from '../models/ListIngestionPipelineDeadLettersResponse.js';
export * from '../models/ListIngestionPipelineHistoryFilterConditions.js';
export * from '../models/ListIngestionPipelineHistoryRequest.js';
export * from '../models/ListIngestionPipelineHistoryResponse.js';
export * from '../models/ListIngestionPipelinePartitionsFilterConditions.js';
export * from '../models/ListIngestionPipelinePartitionsRequest.js';
export * from '../models/ListIngestionPipelinePartitionsResponse.js';
export * from '../models/ListIngestionPipelineTagsResponse.js';
export * from '../models/ListIngestionPipelinesFilterConditions.js';
export * from '../models/ListIngestionPipelinesRequest.js';
export * from '../models/ListIngestionPipelinesResponse.js';
export * from '../models/ListJobTemplatesFilterConditions.js';
export * from '../models/ListJobTemplatesRequest.js';
export * from '../models/ListJobTemplatesResponse.js';
export * from '../models/ListMaintenanceRunsFilterConditions.js';
export * from '../models/ListMaintenanceRunsRequest.js';
export * from '../models/ListMaintenanceRunsResponse.js';
export * from '../models/ListNotebooksFilterConditions.js';
export * from '../models/ListNotebooksRequest.js';
export * from '../models/ListNotebooksResponse.js';
export * from '../models/ListRepositoryAssetsResponse.js';
export * from '../models/ListSavedQueriesFilterConditions.js';
export * from '../models/ListSavedQueriesRequest.js';
export * from '../models/ListSavedQueriesResponse.js';
export * from '../models/ListSparkEnginesFilterConditions.js';
export * from '../models/ListSparkEnginesRequest.js';
export * from '../models/ListSparkEnginesResponse.js';
export * from '../models/ListSparkJobsFilterConditions.js';
export * from '../models/ListSparkJobsRequest.js';
export * from '../models/ListSparkJobsResponse.js';
export * from '../models/ListSqlEnginesFilterConditions.js';
export * from '../models/ListSqlEnginesRequest.js';
export * from '../models/ListSqlEnginesResponse.js';
export * from '../models/ListSqlQueryExecutionsFilterConditions.js';
export * from '../models/ListSqlQueryExecutionsRequest.js';
export * from '../models/ListSqlQueryExecutionsResponse.js';
export * from '../models/ListTableContextFilesResponse.js';
export * from '../models/ListTableContextVersionsResponse.js';
export * from '../models/ListTableContextsResponse.js';
export * from '../models/ListTableMaintenanceRunsFilterConditions.js';
export * from '../models/ListTableMaintenanceRunsRequest.js';
export * from '../models/ListTableMaintenanceRunsResponse.js';
export * from '../models/ListWorkspacesFilterConditions.js';
export * from '../models/ListWorkspacesRequest.js';
export * from '../models/ListWorkspacesResponse.js';
export * from '../models/ListZeroEtlPoliciesFilterConditions.js';
export * from '../models/ListZeroEtlPoliciesRequest.js';
export * from '../models/ListZeroEtlPoliciesResponse.js';
export * from '../models/LooksLike.js';
export * from '../models/MaintenanceMetric.js';
export * from '../models/MaintenanceMetricUnit.js';
export * from '../models/MaintenanceRun.js';
export * from '../models/MaintenanceRunSortField.js';
export * from '../models/MaintenanceRunStatus.js';
export * from '../models/MaintenanceRunStatusFilters.js';
export * from '../models/MaintenanceRunType.js';
export * from '../models/MaintenanceRunTypeFilters.js';
export * from '../models/MergeState.js';
export * from '../models/MetricExportDestination.js';
export * from '../models/MetricExportDestinationSecretRef.js';
export * from '../models/MetricExportDestinationType.js';
export * from '../models/MetricTimeseries.js';
export * from '../models/MetricTimeseriesPoint.js';
export * from '../models/MoveDraftFileInput.js';
export * from '../models/NativeStreamAggregationConfig.js';
export * from '../models/NativeStreamAggregationDerivedColumn.js';
export * from '../models/NativeStreamAggregationEntryLookback.js';
export * from '../models/NativeStreamAggregationEntryMetric.js';
export * from '../models/NativeStreamAggregationEntryRule.js';
export * from '../models/NativeStreamAggregationMetric.js';
export * from '../models/NativeStreamAggregationPlacement.js';
export * from '../models/NativeStreamAggregationServing.js';
export * from '../models/NativeStreamAggregationServingFreshness.js';
export * from '../models/NativeStreamAggregationSubMetric.js';
export * from '../models/NativeStreamBloomFilterWriteMode.js';
export * from '../models/NativeStreamCastOverflowAction.js';
export * from '../models/NativeStreamClusterCurve.js';
export * from '../models/NativeStreamDedupConfig.js';
export * from '../models/NativeStreamEventTimeShiftConfig.js';
export * from '../models/NativeStreamKeyIndexScope.js';
export * from '../models/NativeStreamListOutputField.js';
export * from '../models/NativeStreamListOutputKind.js';
export * from '../models/NativeStreamListOutputType.js';
export * from '../models/NativeStreamListTransformColumn.js';
export * from '../models/NativeStreamMapKeyType.js';
export * from '../models/NativeStreamMapOutputField.js';
export * from '../models/NativeStreamMapOutputKind.js';
export * from '../models/NativeStreamMapOutputType.js';
export * from '../models/NativeStreamMapTransformColumn.js';
export * from '../models/NativeStreamNewColumnPolicy.js';
export * from '../models/NativeStreamOutputField.js';
export * from '../models/NativeStreamOutputType.js';
export * from '../models/NativeStreamProbeFilterReport.js';
export * from '../models/NativeStreamProbeIssue.js';
export * from '../models/NativeStreamProbeSamplingReport.js';
export * from '../models/NativeStreamProfileSampleConfig.js';
export * from '../models/NativeStreamProperties.js';
export * from '../models/NativeStreamRole.js';
export * from '../models/NativeStreamSamplingConfig.js';
export * from '../models/NativeStreamSamplingFeature.js';
export * from '../models/NativeStreamScalarOutputField.js';
export * from '../models/NativeStreamScalarOutputKind.js';
export * from '../models/NativeStreamScalarOutputType.js';
export * from '../models/NativeStreamScalarTransformColumn.js';
export * from '../models/NativeStreamScalarTransformKind.js';
export * from '../models/NativeStreamSchemaColumn.js';
export * from '../models/NativeStreamSchemaColumnType.js';
export * from '../models/NativeStreamSchemaConfig.js';
export * from '../models/NativeStreamSpoolConfig.js';
export * from '../models/NativeStreamStatKind.js';
export * from '../models/NativeStreamStatsConfig.js';
export * from '../models/NativeStreamStructOutputField.js';
export * from '../models/NativeStreamStructOutputKind.js';
export * from '../models/NativeStreamStructOutputType.js';
export * from '../models/NativeStreamStructTransformColumn.js';
export * from '../models/NativeStreamTransformColumn.js';
export * from '../models/NativeStreamTransformConfig.js';
export * from '../models/NativeStreamTransformProbeRequest.js';
export * from '../models/NativeStreamTransformProbeResponse.js';
export * from '../models/NativeStreamTransformUdf.js';
export * from '../models/NativeStreamUntrackedAction.js';
export * from '../models/NativeStreamUpsertConfig.js';
export * from '../models/NativeStreamVariantShreddingConfig.js';
export * from '../models/NativeStreamWeightMode.js';
export * from '../models/Notebook.js';
export * from '../models/NotebookExecutionOutput.js';
export * from '../models/NotebookExecutionResult.js';
export * from '../models/NotebookSession.js';
export * from '../models/NotebookSessionStatus.js';
export * from '../models/NotebookSortField.js';
export * from '../models/NotificationMessageMapping.js';
export * from '../models/NumericDistribution.js';
export * from '../models/OverrideParseResult.js';
export * from '../models/OverrideSampleExample.js';
export * from '../models/PageResponseEnvelope.js';
export * from '../models/PaimonClusteringStrategy.js';
export * from '../models/PaimonRestAuthMode.js';
export * from '../models/PaimonRestCatalogConfig.js';
export * from '../models/PaimonSinkProperties.js';
export * from '../models/ParsedValue.js';
export * from '../models/PartitionCandidate.js';
export * from '../models/PartitionField.js';
export * from '../models/PartitionFormat.js';
export * from '../models/PartitionSegmentType.js';
export * from '../models/PartitionTransform.js';
export * from '../models/PartitionType.js';
export * from '../models/PatchIngestionPipelineInput.js';
export * from '../models/PathPartitionsTimestamp.js';
export * from '../models/PathPartitionsTimestampGranularity.js';
export * from '../models/PathSegment.js';
export * from '../models/PipelineHistoryEntry.js';
export * from '../models/PipelineHistoryField.js';
export * from '../models/PipelineHistoryFieldChange.js';
export * from '../models/PipelineHistoryFieldKind.js';
export * from '../models/PipelineHistoryKind.js';
export * from '../models/PipelineHistoryKindFilters.js';
export * from '../models/PipelineHistorySortField.js';
export * from '../models/PipelineHistorySortOrder.js';
export * from '../models/PipelineHistorySummary.js';
export * from '../models/PipelineRuntimeStopReason.js';
export * from '../models/PodObservation.js';
export * from '../models/PollingConfig.js';
export * from '../models/PrivateLinkStatus.js';
export * from '../models/ProbeError.js';
export * from '../models/ProbeErrorCode.js';
export * from '../models/ProbeFailedResponse.js';
export * from '../models/ProbeFailedResponseError.js';
export * from '../models/PscEndpoint.js';
export * from '../models/PutDraftFileInput.js';
export * from '../models/PutTableContextFileRequest.js';
export * from '../models/PutTableContextFileResponse.js';
export * from '../models/QuantilePoint.js';
export * from '../models/QuantileTrendSeries.js';
export * from '../models/QuarantineBatch.js';
export * from '../models/QuarantineSampleRow.js';
export * from '../models/QuarantineSummary.js';
export * from '../models/RemovalPolicy.js';
export * from '../models/RepositoryAsset.js';
export * from '../models/RepositoryAssetType.js';
export * from '../models/RepositoryRef.js';
export * from '../models/ResolvedRepositorySource.js';
export * from '../models/RewriteTableContextResponse.js';
export * from '../models/RunJobTemplateResponse.js';
export * from '../models/S3DetectPartitionsRequest.js';
export * from '../models/S3DetectPartitionsResponse.js';
export * from '../models/S3FileSampleStats.js';
export * from '../models/S3ListPrefixesRequest.js';
export * from '../models/S3ListPrefixesResponse.js';
export * from '../models/S3PartitionLayout.js';
export * from '../models/S3SampleFileRequest.js';
export * from '../models/S3SampleFileResponse.js';
export * from '../models/S3SampleObject.js';
export * from '../models/S3SourceProperties.js';
export * from '../models/SamplingSimulationRequest.js';
export * from '../models/SamplingSimulationResponse.js';
export * from '../models/SamplingSimulationSegment.js';
export * from '../models/SamplingSimulationSubset.js';
export * from '../models/SaslSecretProbe.js';
export * from '../models/SaveNotebookContentRequest.js';
export * from '../models/SavedQuery.js';
export * from '../models/SavedQuerySortField.js';
export * from '../models/SchemaChangeEvent.js';
export * from '../models/SchemaChangeKind.js';
export * from '../models/SchemaEvolutionMode.js';
export * from '../models/SchemaField.js';
export * from '../models/SchemaReference.js';
export * from '../models/SchemaRegistryAuthConfig.js';
export * from '../models/SchemaRegistryAuthConfigInput.js';
export * from '../models/SchemaRegistryAuthType.js';
export * from '../models/SchemaRegistryConfig.js';
export * from '../models/SchemaRegistryConfigInput.js';
export * from '../models/SchemaRegistryConnectRequest.js';
export * from '../models/SchemaRegistryConnectResponse.js';
export * from '../models/SchemaRegistryResolveSubjectRequest.js';
export * from '../models/SchemaRegistryResolveSubjectResponse.js';
export * from '../models/SchemaRegistrySchemaByIdRequest.js';
export * from '../models/SchemaRegistrySchemaRequest.js';
export * from '../models/SchemaRegistrySchemaResponse.js';
export * from '../models/SchemaRegistrySubject.js';
export * from '../models/SchemaRegistrySubjectsRequest.js';
export * from '../models/SchemaRegistrySubjectsResponse.js';
export * from '../models/SecretRef.js';
export * from '../models/SecretRefAws.js';
export * from '../models/SecretRefGcp.js';
export * from '../models/SecretRefInput.js';
export * from '../models/SecretRefInputAws.js';
export * from '../models/SecretRefInputGcp.js';
export * from '../models/SecurityGroupRule.js';
export * from '../models/SecurityGroupRuleProtocol.js';
export * from '../models/SegmentType.js';
export * from '../models/SemanticLayerBuildResponse.js';
export * from '../models/SendCommitterCommandRequest.js';
export * from '../models/SendCommitterCommandResponse.js';
export * from '../models/SortAggregationServingTokenBy.js';
export * from '../models/SortColumnSpec.js';
export * from '../models/SortCredentialsProfileBy.js';
export * from '../models/SortDashboardBy.js';
export * from '../models/SortDataCatalogBy.js';
export * from '../models/SortGitRepositoryBy.js';
export * from '../models/SortGraphBy.js';
export * from '../models/SortIngestionPartitionBy.js';
export * from '../models/SortIngestionPipelineBy.js';
export * from '../models/SortIngestionPipelineDeadLetterBy.js';
export * from '../models/SortJobTemplateBy.js';
export * from '../models/SortMaintenanceRunBy.js';
export * from '../models/SortNotebookBy.js';
export * from '../models/SortOrder.js';
export * from '../models/SortPipelineHistoryBy.js';
export * from '../models/SortSavedQueryBy.js';
export * from '../models/SortSparkEngineBy.js';
export * from '../models/SortSparkJobBy.js';
export * from '../models/SortSqlEngineBy.js';
export * from '../models/SortSqlQueryExecutionBy.js';
export * from '../models/SortWorkspaceBy.js';
export * from '../models/SortZeroEtlPolicyBy.js';
export * from '../models/SourceShardByPathPartition.js';
export * from '../models/SparkEngine.js';
export * from '../models/SparkEngineSortField.js';
export * from '../models/SparkEngineStatus.js';
export * from '../models/SparkEngineStatusFilters.js';
export * from '../models/SparkJob.js';
export * from '../models/SparkJobRequestedSource.js';
export * from '../models/SparkJobResolvedSource.js';
export * from '../models/SparkJobRetryPolicy.js';
export * from '../models/SparkJobSortField.js';
export * from '../models/SparkJobSource.js';
export * from '../models/SparkJobSourceInput.js';
export * from '../models/SparkJobSourceType.js';
export * from '../models/SparkJobSparkSubmitParams.js';
export * from '../models/SparkJobStatus.js';
export * from '../models/SparkJobStatusFilters.js';
export * from '../models/SparkJobStorageConfig.js';
export * from '../models/SqlEngine.js';
export * from '../models/SqlEngineSortField.js';
export * from '../models/SqlEngineStatus.js';
export * from '../models/SqlEngineStatusFilters.js';
export * from '../models/SqlEngineType.js';
export * from '../models/SqlQueryExecution.js';
export * from '../models/SqlQueryExecutionResult.js';
export * from '../models/SqlQueryExecutionResultColumn.js';
export * from '../models/SqlQueryExecutionSortField.js';
export * from '../models/SqlQueryExecutionStatus.js';
export * from '../models/SqlQueryExecutionStatusFilters.js';
export * from '../models/SqsQueuePolicyProbeError.js';
export * from '../models/SqsQueuePolicyProbeRequest.js';
export * from '../models/SqsQueuePolicyProbeResponse.js';
export * from '../models/SqsQueuePolicyProbeStatus.js';
export * from '../models/StartGitIntegrationAuthorizationInput.js';
export * from '../models/StartGitIntegrationAuthorizationResponse.js';
export * from '../models/StartNotebookSessionInput.js';
export * from '../models/StartSparkJobDirectParams.js';
export * from '../models/StartSparkJobDirectParamsSource.js';
export * from '../models/StartSparkJobInput.js';
export * from '../models/StartSparkJobTemplateParams.js';
export * from '../models/StartSqlQueryExecutionInput.js';
export * from '../models/StatWidget.js';
export * from '../models/StateListItem.js';
export * from '../models/StateListWidget.js';
export * from '../models/StorageConfig.js';
export * from '../models/StreamCursorHalt.js';
export * from '../models/StreamCursorResetRequest.js';
export * from '../models/StringFilters.js';
export * from '../models/SubjectNamingStrategy.js';
export * from '../models/SubjectResolution.js';
export * from '../models/TableColumnProfile.js';
export * from '../models/TableColumnStats.js';
export * from '../models/TableColumnTopValue.js';
export * from '../models/TableContextColumn.js';
export * from '../models/TableContextColumnEdit.js';
export * from '../models/TableContextColumnUse.js';
export * from '../models/TableContextDecidedColumn.js';
export * from '../models/TableContextEdit.js';
export * from '../models/TableContextFile.js';
export * from '../models/TableContextKind.js';
export * from '../models/TableContextKindColumn.js';
export * from '../models/TableContextKindEdit.js';
export * from '../models/TableContextKinds.js';
export * from '../models/TableContextLeftOut.js';
export * from '../models/TableContextMetric.js';
export * from '../models/TableContextMetricEdit.js';
export * from '../models/TableContextNewNote.js';
export * from '../models/TableContextNote.js';
export * from '../models/TableContextNoteEdit.js';
export * from '../models/TableContextOverview.js';
export * from '../models/TableContextRejectedMetric.js';
export * from '../models/TableContextRelease.js';
export * from '../models/TableContextRewrite.js';
export * from '../models/TableContextRewriteState.js';
export * from '../models/TableContextSameColumns.js';
export * from '../models/TableContextSegment.js';
export * from '../models/TableContextSegmentColumn.js';
export * from '../models/TableContextSegmentColumnDecision.js';
export * from '../models/TableContextSegmentMap.js';
export * from '../models/TableContextSegmentMapCell.js';
export * from '../models/TableContextSegmentMapRow.js';
export * from '../models/TableContextSegmentMark.js';
export * from '../models/TableContextSegments.js';
export * from '../models/TableContextSummary.js';
export * from '../models/TableContextVersion.js';
export * from '../models/TableContextVersionReason.js';
export * from '../models/TableDataQualityPartitionRow.js';
export * from '../models/TableDataQualitySettings.js';
export * from '../models/TableEventTimeBucket.js';
export * from '../models/TableFormat.js';
export * from '../models/TableLiveView.js';
export * from '../models/TableMaintenanceConfig.js';
export * from '../models/TableRetentionConfig.js';
export * from '../models/TableSampleCell.js';
export * from '../models/TableSignal.js';
export * from '../models/TableSignalKind.js';
export * from '../models/TableSourceProperties.js';
export * from '../models/TableSourceStart.js';
export * from '../models/TableSourceStartKind.js';
export * from '../models/TableWidget.js';
export * from '../models/TelemetryExportApplyStatus.js';
export * from '../models/TelemetryExportAuthMode.js';
export * from '../models/TelemetryExportOtlpProtocol.js';
export * from '../models/Threshold.js';
export * from '../models/ThresholdMode.js';
export * from '../models/ThresholdStep.js';
export * from '../models/TimeseriesChartKind.js';
export * from '../models/TimeseriesWidget.js';
export * from '../models/TlsSecretProbe.js';
export * from '../models/TreeEntryType.js';
export * from '../models/TriggeredAction.js';
export * from '../models/UnsupportedSnapshotPolicy.js';
export * from '../models/UpdateAwsPrivateLinkInput.js';
export * from '../models/UpdateCredentialsProfileInput.js';
export * from '../models/UpdateCredentialsProfileInputAws.js';
export * from '../models/UpdateCredentialsProfileInputGcp.js';
export * from '../models/UpdateDashboardInput.js';
export * from '../models/UpdateGraphInput.js';
export * from '../models/UpdateIngestionPipelineInput.js';
export * from '../models/UpdateJobTemplateInput.js';
export * from '../models/UpdateMetricExportDestinationInput.js';
export * from '../models/UpdateMetricExportDestinationInputSecretRef.js';
export * from '../models/UpdateNotebookInput.js';
export * from '../models/UpdatePscEndpointInput.js';
export * from '../models/UpdateSavedQueryInput.js';
export * from '../models/UpdateTableContextRequest.js';
export * from '../models/UpdateTableContextResponse.js';
export * from '../models/UpdateTableDataQualitySettingsRequest.js';
export * from '../models/UpdateTableMaintenanceConfigInput.js';
export * from '../models/UpdateWorkspaceLoggingSettingsInput.js';
export * from '../models/UpdateWorkspaceLoggingSettingsInputAws.js';
export * from '../models/UpdateWorkspaceLoggingSettingsInputGcp.js';
export * from '../models/UpdateWorkspaceMaintenanceSettingsRequest.js';
export * from '../models/UpdateWorkspaceMetricsSettingsInput.js';
export * from '../models/UpdateWorkspaceMetricsSettingsInputAws.js';
export * from '../models/UpdateWorkspaceMetricsSettingsInputGcp.js';
export * from '../models/UpdateWorkspaceStorageAccessConfigurationInput.js';
export * from '../models/UpdateWorkspaceStorageAccessConfigurationInputAws.js';
export * from '../models/UpdateWorkspaceStorageAccessConfigurationInputGcp.js';
export * from '../models/UpdateZeroEtlPolicyInput.js';
export * from '../models/ValueMapping.js';
export * from '../models/ValueMappingResult.js';
export * from '../models/ValueMappingType.js';
export * from '../models/VpcPeeringStatus.js';
export * from '../models/WarmCapacity.js';
export * from '../models/Widget.js';
export * from '../models/WidgetLayout.js';
export * from '../models/WidgetTableCell.js';
export * from '../models/WidgetTableColumn.js';
export * from '../models/WidgetTableRow.js';
export * from '../models/WidgetType.js';
export * from '../models/Workspace.js';
export * from '../models/WorkspaceAllowedPrincipal.js';
export * from '../models/WorkspaceAllowedPrincipalInput.js';
export * from '../models/WorkspaceAws.js';
export * from '../models/WorkspaceAwsStorageAccessConfiguration.js';
export * from '../models/WorkspaceGcp.js';
export * from '../models/WorkspaceGcpStorageAccessConfiguration.js';
export * from '../models/WorkspaceLoggingSettings.js';
export * from '../models/WorkspaceLoggingSettingsAws.js';
export * from '../models/WorkspaceLoggingSettingsGcp.js';
export * from '../models/WorkspaceMaintenanceSettings.js';
export * from '../models/WorkspaceMetricsSettings.js';
export * from '../models/WorkspaceMetricsSettingsAws.js';
export * from '../models/WorkspaceMetricsSettingsGcp.js';
export * from '../models/WorkspaceNetworkingSettings.js';
export * from '../models/WorkspaceNetworkingSettingsAws.js';
export * from '../models/WorkspaceNetworkingSettingsGcp.js';
export * from '../models/WorkspaceSortField.js';
export * from '../models/WorkspaceStatus.js';
export * from '../models/WorkspaceStatusFilters.js';
export * from '../models/WorkspaceStorageAccessConfiguration.js';
export * from '../models/WorkspaceStorageAccessConfigurationAws.js';
export * from '../models/WorkspaceStorageAccessConfigurationGcp.js';
export * from '../models/WorkspaceStorageAllowedCredentialsProfile.js';
export * from '../models/WorkspaceStorageAllowedCredentialsProfileInput.js';
export * from '../models/WorkspaceStoragePermission.js';
export * from '../models/ZeroEtlIdentityColumnField.js';
export * from '../models/ZeroEtlIdentityColumnSpec.js';
export * from '../models/ZeroEtlPolicy.js';
export * from '../models/ZeroEtlPolicySortField.js';
export * from '../models/ZeroEtlResourceSelector.js';
export * from '../models/ZeroEtlRoutingMode.js';
export * from '../models/ZeroEtlRoutingPolicy.js';
import { AggregationServingToken } from '../models/AggregationServingToken.js';
import { AlertChannel } from '../models/AlertChannel.js';
import { AnalyzeSqlQueryRequest } from '../models/AnalyzeSqlQueryRequest.js';
import { AvailableRepository } from '../models/AvailableRepository.js';
import { AwsCredentialProfile } from '../models/AwsCredentialProfile.js';
import { AwsCredentialProfileInput } from '../models/AwsCredentialProfileInput.js';
import { AwsLoggingSettings } from '../models/AwsLoggingSettings.js';
import { AwsLoggingSettingsInput } from '../models/AwsLoggingSettingsInput.js';
import { AwsMetricsSettings } from '../models/AwsMetricsSettings.js';
import { AwsMetricsSettingsInput } from '../models/AwsMetricsSettingsInput.js';
import { AwsNetworkingSettings } from '../models/AwsNetworkingSettings.js';
import { AwsNetworkingSettingsVpcPeering } from '../models/AwsNetworkingSettingsVpcPeering.js';
import { AwsPrincipal } from '../models/AwsPrincipal.js';
import { AwsPrincipalInput } from '../models/AwsPrincipalInput.js';
import { AwsPrivateLink } from '../models/AwsPrivateLink.js';
import { AwsSecretsManagerRef } from '../models/AwsSecretsManagerRef.js';
import { AwsSecretsManagerRefInput } from '../models/AwsSecretsManagerRefInput.js';
import { AwsStorageAccessConfigurationInput } from '../models/AwsStorageAccessConfigurationInput.js';
import { AwsVpcPeering } from '../models/AwsVpcPeering.js';
import { AwsWorkspaceInfo } from '../models/AwsWorkspaceInfo.js';
import { BatchDraftCommitInput } from '../models/BatchDraftCommitInput.js';
import { BatchGetAggregationRowsRequest } from '../models/BatchGetAggregationRowsRequest.js';
import { BatchGetAggregationRowsResponse } from '../models/BatchGetAggregationRowsResponse.js';
import { BatchIngestionPipelineMetricsRangeRequest } from '../models/BatchIngestionPipelineMetricsRangeRequest.js';
import { BatchIngestionPipelineMetricsRangeResponse } from '../models/BatchIngestionPipelineMetricsRangeResponse.js';
import { BatchIngestionPipelineMetricsRequest } from '../models/BatchIngestionPipelineMetricsRequest.js';
import { BatchIngestionPipelineMetricsResponse } from '../models/BatchIngestionPipelineMetricsResponse.js';
import { BiglakeCatalogProperties } from '../models/BiglakeCatalogProperties.js';
import { BooleanFilters } from '../models/BooleanFilters.js';
import { BucketFileProbeRequest } from '../models/BucketFileProbeRequest.js';
import { BucketFileProbeResponse } from '../models/BucketFileProbeResponse.js';
import { BucketFilesSourceProperties } from '../models/BucketFilesSourceProperties.js';
import { BucketNotificationProbeRequest } from '../models/BucketNotificationProbeRequest.js';
import { BucketNotificationProbeResponse } from '../models/BucketNotificationProbeResponse.js';
import { BucketPathPartitionSpec } from '../models/BucketPathPartitionSpec.js';
import { CatalogAccessRequest } from '../models/CatalogAccessRequest.js';
import { CatalogAccessResponse } from '../models/CatalogAccessResponse.js';
import { CatalogCheckNameRequest } from '../models/CatalogCheckNameRequest.js';
import { CatalogCheckNameResponse } from '../models/CatalogCheckNameResponse.js';
import { CatalogDatabase } from '../models/CatalogDatabase.js';
import { CatalogListDatabasesRequest } from '../models/CatalogListDatabasesRequest.js';
import { CatalogListDatabasesResponse } from '../models/CatalogListDatabasesResponse.js';
import { CategoryTrendSeries } from '../models/CategoryTrendSeries.js';
import { CloudPrincipal } from '../models/CloudPrincipal.js';
import { CloudPrincipalAws } from '../models/CloudPrincipalAws.js';
import { CloudPrincipalGcp } from '../models/CloudPrincipalGcp.js';
import { CloudPrincipalInput } from '../models/CloudPrincipalInput.js';
import { CloudPrincipalInputAws } from '../models/CloudPrincipalInputAws.js';
import { CloudPrincipalInputGcp } from '../models/CloudPrincipalInputGcp.js';
import { ColumnNullRate } from '../models/ColumnNullRate.js';
import { CommitChangeInput } from '../models/CommitChangeInput.js';
import { CommitterCompactionStrategyStats } from '../models/CommitterCompactionStrategyStats.js';
import { CommitterMaintenanceStats } from '../models/CommitterMaintenanceStats.js';
import { CommitterSealCompactionStats } from '../models/CommitterSealCompactionStats.js';
import { CompleteGitIntegrationInput } from '../models/CompleteGitIntegrationInput.js';
import { Condition } from '../models/Condition.js';
import { ConnectGitRepositoryInput } from '../models/ConnectGitRepositoryInput.js';
import { CreateAggregationServingTokenRequest } from '../models/CreateAggregationServingTokenRequest.js';
import { CreateAggregationServingTokenResponse } from '../models/CreateAggregationServingTokenResponse.js';
import { CreateAwsPrivateLinkInput } from '../models/CreateAwsPrivateLinkInput.js';
import { CreateAwsVpcPeeringInput } from '../models/CreateAwsVpcPeeringInput.js';
import { CreateCredentialsProfileInput } from '../models/CreateCredentialsProfileInput.js';
import { CreateDashboardInput } from '../models/CreateDashboardInput.js';
import { CreateDataCatalogInput } from '../models/CreateDataCatalogInput.js';
import { CreateDataCatalogInputGlueProperties } from '../models/CreateDataCatalogInputGlueProperties.js';
import { CreateDataCatalogInputIcebergRestProperties } from '../models/CreateDataCatalogInputIcebergRestProperties.js';
import { CreateGcpVpcPeeringInput } from '../models/CreateGcpVpcPeeringInput.js';
import { CreateGraphInput } from '../models/CreateGraphInput.js';
import { CreateIngestionPipelineInput } from '../models/CreateIngestionPipelineInput.js';
import { CreateJobTemplateInput } from '../models/CreateJobTemplateInput.js';
import { CreateNotebookInput } from '../models/CreateNotebookInput.js';
import { CreatePscEndpointInput } from '../models/CreatePscEndpointInput.js';
import { CreatePullRequestInput } from '../models/CreatePullRequestInput.js';
import { CreateSavedQueryInput } from '../models/CreateSavedQueryInput.js';
import { CreateSparkEngineInput } from '../models/CreateSparkEngineInput.js';
import { CreateSqlEngineInput } from '../models/CreateSqlEngineInput.js';
import { CreateZeroEtlPolicyInput } from '../models/CreateZeroEtlPolicyInput.js';
import { CredentialsProbeAssumeResponse } from '../models/CredentialsProbeAssumeResponse.js';
import { CredentialsProbeWriteResponse } from '../models/CredentialsProbeWriteResponse.js';
import { CredentialsProfile } from '../models/CredentialsProfile.js';
import { CredentialsProfileAws } from '../models/CredentialsProfileAws.js';
import { CredentialsProfileGcp } from '../models/CredentialsProfileGcp.js';
import { CriticalColumnSlo } from '../models/CriticalColumnSlo.js';
import { CsvOptions } from '../models/CsvOptions.js';
import { Dashboard } from '../models/Dashboard.js';
import { DashboardGraph } from '../models/DashboardGraph.js';
import { DashboardGraphLayout } from '../models/DashboardGraphLayout.js';
import { DashboardWithGraphs } from '../models/DashboardWithGraphs.js';
import { DataCatalog } from '../models/DataCatalog.js';
import { DataCatalogBiglakeProperties } from '../models/DataCatalogBiglakeProperties.js';
import { DataCatalogGlueProperties } from '../models/DataCatalogGlueProperties.js';
import { DataCatalogIcebergRestProperties } from '../models/DataCatalogIcebergRestProperties.js';
import { DataCatalogTypeFilters } from '../models/DataCatalogTypeFilters.js';
import { DataQualityAlertRouting } from '../models/DataQualityAlertRouting.js';
import { DataQualityDashboard } from '../models/DataQualityDashboard.js';
import { DataQualityDashboardSection } from '../models/DataQualityDashboardSection.js';
import { DataQualityHeadlineKpi } from '../models/DataQualityHeadlineKpi.js';
import { DataQualityHealthTrendSignal } from '../models/DataQualityHealthTrendSignal.js';
import { DataQualityNavStatus } from '../models/DataQualityNavStatus.js';
import { DataQualityTableMeta } from '../models/DataQualityTableMeta.js';
import { DateRangeFilter } from '../models/DateRangeFilter.js';
import { DetectedFormat } from '../models/DetectedFormat.js';
import { DistributionBucket } from '../models/DistributionBucket.js';
import { DistributionColumn } from '../models/DistributionColumn.js';
import { DistributionTrend } from '../models/DistributionTrend.js';
import { DistributionTrendDistinct } from '../models/DistributionTrendDistinct.js';
import { EnumCategoryShare } from '../models/EnumCategoryShare.js';
import { EnumDistribution } from '../models/EnumDistribution.js';
import { ExecuteNotebookCodeInput } from '../models/ExecuteNotebookCodeInput.js';
import { FieldConfig } from '../models/FieldConfig.js';
import { FieldOverride } from '../models/FieldOverride.js';
import { FlinkDeploymentObservation } from '../models/FlinkDeploymentObservation.js';
import { GaussianFit } from '../models/GaussianFit.js';
import { GcpCredentialProfile } from '../models/GcpCredentialProfile.js';
import { GcpCredentialProfileInput } from '../models/GcpCredentialProfileInput.js';
import { GcpLoggingSettings } from '../models/GcpLoggingSettings.js';
import { GcpLoggingSettingsInput } from '../models/GcpLoggingSettingsInput.js';
import { GcpMetricsSettings } from '../models/GcpMetricsSettings.js';
import { GcpMetricsSettingsInput } from '../models/GcpMetricsSettingsInput.js';
import { GcpNetworkingSettings } from '../models/GcpNetworkingSettings.js';
import { GcpNetworkingSettingsVpcPeering } from '../models/GcpNetworkingSettingsVpcPeering.js';
import { GcpPrincipal } from '../models/GcpPrincipal.js';
import { GcpPrincipalInput } from '../models/GcpPrincipalInput.js';
import { GcpSecretManagerRef } from '../models/GcpSecretManagerRef.js';
import { GcpSecretManagerRefInput } from '../models/GcpSecretManagerRefInput.js';
import { GcpStorageAccessConfigurationInput } from '../models/GcpStorageAccessConfigurationInput.js';
import { GcpVpcPeering } from '../models/GcpVpcPeering.js';
import { GcpWorkspaceInfo } from '../models/GcpWorkspaceInfo.js';
import { GcsListPrefixesRequest } from '../models/GcsListPrefixesRequest.js';
import { GcsListPrefixesResponse } from '../models/GcsListPrefixesResponse.js';
import { GcsSampleObject } from '../models/GcsSampleObject.js';
import { GcsSourceProperties } from '../models/GcsSourceProperties.js';
import { GetIngestionPipelineErrorsResponse } from '../models/GetIngestionPipelineErrorsResponse.js';
import { GetIngestionPipelineSchemaResponse } from '../models/GetIngestionPipelineSchemaResponse.js';
import { GetIngestionPipelineSpendLedgerResponse } from '../models/GetIngestionPipelineSpendLedgerResponse.js';
import { GetNotebookContent200Response } from '../models/GetNotebookContent200Response.js';
import { GetStreamCursorHaltsResponse } from '../models/GetStreamCursorHaltsResponse.js';
import { GetTableContextFileResponse } from '../models/GetTableContextFileResponse.js';
import { GetTableContextResponse } from '../models/GetTableContextResponse.js';
import { GetTableContextRewriteResponse } from '../models/GetTableContextRewriteResponse.js';
import { GetTableDataQualityColumnInspectResponse } from '../models/GetTableDataQualityColumnInspectResponse.js';
import { GetTableDataQualityCompletenessResponse } from '../models/GetTableDataQualityCompletenessResponse.js';
import { GetTableDataQualityDistributionColumnResponse } from '../models/GetTableDataQualityDistributionColumnResponse.js';
import { GetTableDataQualityDistributionResponse } from '../models/GetTableDataQualityDistributionResponse.js';
import { GetTableDataQualityEventTimeHistogramResponse } from '../models/GetTableDataQualityEventTimeHistogramResponse.js';
import { GetTableDataQualityHeaderResponse } from '../models/GetTableDataQualityHeaderResponse.js';
import { GetTableDataQualityHealthTrendResponse } from '../models/GetTableDataQualityHealthTrendResponse.js';
import { GetTableDataQualityOverviewResponse } from '../models/GetTableDataQualityOverviewResponse.js';
import { GetTableDataQualityPartitionsResponse } from '../models/GetTableDataQualityPartitionsResponse.js';
import { GetTableDataQualityProfileResponse } from '../models/GetTableDataQualityProfileResponse.js';
import { GetTableDataQualityQuarantineBatchResponse } from '../models/GetTableDataQualityQuarantineBatchResponse.js';
import { GetTableDataQualityQuarantineResponse } from '../models/GetTableDataQualityQuarantineResponse.js';
import { GetTableDataQualitySchemaChangesResponse } from '../models/GetTableDataQualitySchemaChangesResponse.js';
import { GetTableDataQualitySettingsResponse } from '../models/GetTableDataQualitySettingsResponse.js';
import { GetTableDataQualityWidgetSeriesResponse } from '../models/GetTableDataQualityWidgetSeriesResponse.js';
import { GetTableSampleResponse } from '../models/GetTableSampleResponse.js';
import { GetTableSignalsResponse } from '../models/GetTableSignalsResponse.js';
import { GetTableSnapshotsResponse } from '../models/GetTableSnapshotsResponse.js';
import { GitCommitResult } from '../models/GitCommitResult.js';
import { GitDiffEntry } from '../models/GitDiffEntry.js';
import { GitDiffResponse } from '../models/GitDiffResponse.js';
import { GitDraft } from '../models/GitDraft.js';
import { GitDraftPullRequest } from '../models/GitDraftPullRequest.js';
import { GitFileResponse } from '../models/GitFileResponse.js';
import { GitIntegration } from '../models/GitIntegration.js';
import { GitMergeResult } from '../models/GitMergeResult.js';
import { GitProviderFilters } from '../models/GitProviderFilters.js';
import { GitPullRequest } from '../models/GitPullRequest.js';
import { GitRepository } from '../models/GitRepository.js';
import { GitRepositoryStatusFilters } from '../models/GitRepositoryStatusFilters.js';
import { GitTreeEntry } from '../models/GitTreeEntry.js';
import { GitTreeResponse } from '../models/GitTreeResponse.js';
import { GlueCatalogProperties } from '../models/GlueCatalogProperties.js';
import { GlueCatalogPropertiesInput } from '../models/GlueCatalogPropertiesInput.js';
import { IcebergCompactionConfig } from '../models/IcebergCompactionConfig.js';
import { IcebergRestCatalogProperties } from '../models/IcebergRestCatalogProperties.js';
import { IcebergRestCatalogPropertiesCredentialsSecret } from '../models/IcebergRestCatalogPropertiesCredentialsSecret.js';
import { IcebergRestCatalogPropertiesInput } from '../models/IcebergRestCatalogPropertiesInput.js';
import { IcebergRestCatalogPropertiesInputCredentialsSecret } from '../models/IcebergRestCatalogPropertiesInputCredentialsSecret.js';
import { IcebergSinkProperties } from '../models/IcebergSinkProperties.js';
import { IcebergSnapshotEntry } from '../models/IcebergSnapshotEntry.js';
import { IcebergTableColumn } from '../models/IcebergTableColumn.js';
import { IdFilters } from '../models/IdFilters.js';
import { IngestionPartition } from '../models/IngestionPartition.js';
import { IngestionPartitionStatusFilters } from '../models/IngestionPartitionStatusFilters.js';
import { IngestionPipeline } from '../models/IngestionPipeline.js';
import { IngestionPipelineAggregationMetrics } from '../models/IngestionPipelineAggregationMetrics.js';
import { IngestionPipelineDeadLetter } from '../models/IngestionPipelineDeadLetter.js';
import { IngestionPipelineDeadLetterByteRange } from '../models/IngestionPipelineDeadLetterByteRange.js';
import { IngestionPipelineDeadLetterErrorGroup } from '../models/IngestionPipelineDeadLetterErrorGroup.js';
import { IngestionPipelineDeadLetterSummary } from '../models/IngestionPipelineDeadLetterSummary.js';
import { IngestionPipelineErrorClass } from '../models/IngestionPipelineErrorClass.js';
import { IngestionPipelineIssue } from '../models/IngestionPipelineIssue.js';
import { IngestionPipelineLastObservation } from '../models/IngestionPipelineLastObservation.js';
import { IngestionPipelineMetrics } from '../models/IngestionPipelineMetrics.js';
import { IngestionPipelineMetricsRange } from '../models/IngestionPipelineMetricsRange.js';
import { IngestionPipelineObservation } from '../models/IngestionPipelineObservation.js';
import { IngestionPipelineObservationFlinkDeployment } from '../models/IngestionPipelineObservationFlinkDeployment.js';
import { IngestionPipelinePurgeMetrics } from '../models/IngestionPipelinePurgeMetrics.js';
import { IngestionPipelineRetiredAggregation } from '../models/IngestionPipelineRetiredAggregation.js';
import { IngestionPipelineSpendLedgerRow } from '../models/IngestionPipelineSpendLedgerRow.js';
import { IngestionPipelineStatusFilters } from '../models/IngestionPipelineStatusFilters.js';
import { IngestionPipelineTag } from '../models/IngestionPipelineTag.js';
import { JobTemplate } from '../models/JobTemplate.js';
import { JobTemplateRetryPolicy } from '../models/JobTemplateRetryPolicy.js';
import { JobTemplateSchedule } from '../models/JobTemplateSchedule.js';
import { JobTemplateScheduleInput } from '../models/JobTemplateScheduleInput.js';
import { JsonPathSample } from '../models/JsonPathSample.js';
import { K8sEventObservation } from '../models/K8sEventObservation.js';
import { KafkaBatchConfig } from '../models/KafkaBatchConfig.js';
import { KafkaConnectProbeRequest } from '../models/KafkaConnectProbeRequest.js';
import { KafkaConnectProbeResponse } from '../models/KafkaConnectProbeResponse.js';
import { KafkaErrorHandlingConfig } from '../models/KafkaErrorHandlingConfig.js';
import { KafkaInferSchemaRequest } from '../models/KafkaInferSchemaRequest.js';
import { KafkaInferSchemaResponse } from '../models/KafkaInferSchemaResponse.js';
import { KafkaMessageSample } from '../models/KafkaMessageSample.js';
import { KafkaPartitioningConfig } from '../models/KafkaPartitioningConfig.js';
import { KafkaSampleProbeRequest } from '../models/KafkaSampleProbeRequest.js';
import { KafkaSampleProbeResponse } from '../models/KafkaSampleProbeResponse.js';
import { KafkaSchemaOverridesConfig } from '../models/KafkaSchemaOverridesConfig.js';
import { KafkaSecretProbeRequest } from '../models/KafkaSecretProbeRequest.js';
import { KafkaSecretProbeResponse } from '../models/KafkaSecretProbeResponse.js';
import { KafkaSecurityConfig } from '../models/KafkaSecurityConfig.js';
import { KafkaSecurityConfigCredentialsSecret } from '../models/KafkaSecurityConfigCredentialsSecret.js';
import { KafkaSecurityConfigInput } from '../models/KafkaSecurityConfigInput.js';
import { KafkaSecurityConfigInputCredentialsSecret } from '../models/KafkaSecurityConfigInputCredentialsSecret.js';
import { KafkaSecurityConfigInputTlsSecret } from '../models/KafkaSecurityConfigInputTlsSecret.js';
import { KafkaSecurityConfigTlsSecret } from '../models/KafkaSecurityConfigTlsSecret.js';
import { KafkaSourceConfig } from '../models/KafkaSourceConfig.js';
import { KafkaSourceProperties } from '../models/KafkaSourceProperties.js';
import { KafkaSourcePropertiesInput } from '../models/KafkaSourcePropertiesInput.js';
import { KafkaTopicInfo } from '../models/KafkaTopicInfo.js';
import { KafkaTopicPartition } from '../models/KafkaTopicPartition.js';
import { KafkaTopicsProbeRequest } from '../models/KafkaTopicsProbeRequest.js';
import { KafkaTopicsProbeResponse } from '../models/KafkaTopicsProbeResponse.js';
import { ListAggregationServingTokensFilterConditions } from '../models/ListAggregationServingTokensFilterConditions.js';
import { ListAggregationServingTokensRequest } from '../models/ListAggregationServingTokensRequest.js';
import { ListAggregationServingTokensResponse } from '../models/ListAggregationServingTokensResponse.js';
import { ListAvailableRepositoriesResponse } from '../models/ListAvailableRepositoriesResponse.js';
import { ListCredentialsProfilesFilterConditions } from '../models/ListCredentialsProfilesFilterConditions.js';
import { ListCredentialsProfilesRequest } from '../models/ListCredentialsProfilesRequest.js';
import { ListCredentialsProfilesResponse } from '../models/ListCredentialsProfilesResponse.js';
import { ListDashboardsFilterConditions } from '../models/ListDashboardsFilterConditions.js';
import { ListDashboardsRequest } from '../models/ListDashboardsRequest.js';
import { ListDashboardsResponse } from '../models/ListDashboardsResponse.js';
import { ListDataCatalogsFilterConditions } from '../models/ListDataCatalogsFilterConditions.js';
import { ListDataCatalogsRequest } from '../models/ListDataCatalogsRequest.js';
import { ListDataCatalogsResponse } from '../models/ListDataCatalogsResponse.js';
import { ListGitIntegrationsResponse } from '../models/ListGitIntegrationsResponse.js';
import { ListGitRepositoriesFilterConditions } from '../models/ListGitRepositoriesFilterConditions.js';
import { ListGitRepositoriesRequest } from '../models/ListGitRepositoriesRequest.js';
import { ListGitRepositoriesResponse } from '../models/ListGitRepositoriesResponse.js';
import { ListGraphsFilterConditions } from '../models/ListGraphsFilterConditions.js';
import { ListGraphsRequest } from '../models/ListGraphsRequest.js';
import { ListGraphsResponse } from '../models/ListGraphsResponse.js';
import { ListIngestionPipelineDeadLettersRequest } from '../models/ListIngestionPipelineDeadLettersRequest.js';
import { ListIngestionPipelineDeadLettersResponse } from '../models/ListIngestionPipelineDeadLettersResponse.js';
import { ListIngestionPipelineHistoryFilterConditions } from '../models/ListIngestionPipelineHistoryFilterConditions.js';
import { ListIngestionPipelineHistoryRequest } from '../models/ListIngestionPipelineHistoryRequest.js';
import { ListIngestionPipelineHistoryResponse } from '../models/ListIngestionPipelineHistoryResponse.js';
import { ListIngestionPipelinePartitionsFilterConditions } from '../models/ListIngestionPipelinePartitionsFilterConditions.js';
import { ListIngestionPipelinePartitionsRequest } from '../models/ListIngestionPipelinePartitionsRequest.js';
import { ListIngestionPipelinePartitionsResponse } from '../models/ListIngestionPipelinePartitionsResponse.js';
import { ListIngestionPipelineTagsResponse } from '../models/ListIngestionPipelineTagsResponse.js';
import { ListIngestionPipelinesFilterConditions } from '../models/ListIngestionPipelinesFilterConditions.js';
import { ListIngestionPipelinesRequest } from '../models/ListIngestionPipelinesRequest.js';
import { ListIngestionPipelinesResponse } from '../models/ListIngestionPipelinesResponse.js';
import { ListJobTemplatesFilterConditions } from '../models/ListJobTemplatesFilterConditions.js';
import { ListJobTemplatesRequest } from '../models/ListJobTemplatesRequest.js';
import { ListJobTemplatesResponse } from '../models/ListJobTemplatesResponse.js';
import { ListMaintenanceRunsFilterConditions } from '../models/ListMaintenanceRunsFilterConditions.js';
import { ListMaintenanceRunsRequest } from '../models/ListMaintenanceRunsRequest.js';
import { ListMaintenanceRunsResponse } from '../models/ListMaintenanceRunsResponse.js';
import { ListNotebooksFilterConditions } from '../models/ListNotebooksFilterConditions.js';
import { ListNotebooksRequest } from '../models/ListNotebooksRequest.js';
import { ListNotebooksResponse } from '../models/ListNotebooksResponse.js';
import { ListRepositoryAssetsResponse } from '../models/ListRepositoryAssetsResponse.js';
import { ListSavedQueriesFilterConditions } from '../models/ListSavedQueriesFilterConditions.js';
import { ListSavedQueriesRequest } from '../models/ListSavedQueriesRequest.js';
import { ListSavedQueriesResponse } from '../models/ListSavedQueriesResponse.js';
import { ListSparkEnginesFilterConditions } from '../models/ListSparkEnginesFilterConditions.js';
import { ListSparkEnginesRequest } from '../models/ListSparkEnginesRequest.js';
import { ListSparkEnginesResponse } from '../models/ListSparkEnginesResponse.js';
import { ListSparkJobsFilterConditions } from '../models/ListSparkJobsFilterConditions.js';
import { ListSparkJobsRequest } from '../models/ListSparkJobsRequest.js';
import { ListSparkJobsResponse } from '../models/ListSparkJobsResponse.js';
import { ListSqlEnginesFilterConditions } from '../models/ListSqlEnginesFilterConditions.js';
import { ListSqlEnginesRequest } from '../models/ListSqlEnginesRequest.js';
import { ListSqlEnginesResponse } from '../models/ListSqlEnginesResponse.js';
import { ListSqlQueryExecutionsFilterConditions } from '../models/ListSqlQueryExecutionsFilterConditions.js';
import { ListSqlQueryExecutionsRequest } from '../models/ListSqlQueryExecutionsRequest.js';
import { ListSqlQueryExecutionsResponse } from '../models/ListSqlQueryExecutionsResponse.js';
import { ListTableContextFilesResponse } from '../models/ListTableContextFilesResponse.js';
import { ListTableContextVersionsResponse } from '../models/ListTableContextVersionsResponse.js';
import { ListTableContextsResponse } from '../models/ListTableContextsResponse.js';
import { ListTableMaintenanceRunsFilterConditions } from '../models/ListTableMaintenanceRunsFilterConditions.js';
import { ListTableMaintenanceRunsRequest } from '../models/ListTableMaintenanceRunsRequest.js';
import { ListTableMaintenanceRunsResponse } from '../models/ListTableMaintenanceRunsResponse.js';
import { ListWorkspacesFilterConditions } from '../models/ListWorkspacesFilterConditions.js';
import { ListWorkspacesRequest } from '../models/ListWorkspacesRequest.js';
import { ListWorkspacesResponse } from '../models/ListWorkspacesResponse.js';
import { ListZeroEtlPoliciesFilterConditions } from '../models/ListZeroEtlPoliciesFilterConditions.js';
import { ListZeroEtlPoliciesRequest } from '../models/ListZeroEtlPoliciesRequest.js';
import { ListZeroEtlPoliciesResponse } from '../models/ListZeroEtlPoliciesResponse.js';
import { MaintenanceMetric } from '../models/MaintenanceMetric.js';
import { MaintenanceRun } from '../models/MaintenanceRun.js';
import { MaintenanceRunStatusFilters } from '../models/MaintenanceRunStatusFilters.js';
import { MaintenanceRunTypeFilters } from '../models/MaintenanceRunTypeFilters.js';
import { MetricExportDestination } from '../models/MetricExportDestination.js';
import { MetricExportDestinationSecretRef } from '../models/MetricExportDestinationSecretRef.js';
import { MetricTimeseries } from '../models/MetricTimeseries.js';
import { MetricTimeseriesPoint } from '../models/MetricTimeseriesPoint.js';
import { MoveDraftFileInput } from '../models/MoveDraftFileInput.js';
import { NativeStreamAggregationConfig } from '../models/NativeStreamAggregationConfig.js';
import { NativeStreamAggregationDerivedColumn } from '../models/NativeStreamAggregationDerivedColumn.js';
import { NativeStreamAggregationEntryMetric } from '../models/NativeStreamAggregationEntryMetric.js';
import { NativeStreamAggregationEntryRule } from '../models/NativeStreamAggregationEntryRule.js';
import { NativeStreamAggregationMetric } from '../models/NativeStreamAggregationMetric.js';
import { NativeStreamAggregationServing } from '../models/NativeStreamAggregationServing.js';
import { NativeStreamAggregationSubMetric } from '../models/NativeStreamAggregationSubMetric.js';
import { NativeStreamDedupConfig } from '../models/NativeStreamDedupConfig.js';
import { NativeStreamEventTimeShiftConfig } from '../models/NativeStreamEventTimeShiftConfig.js';
import { NativeStreamListOutputField } from '../models/NativeStreamListOutputField.js';
import { NativeStreamListOutputType } from '../models/NativeStreamListOutputType.js';
import { NativeStreamListTransformColumn } from '../models/NativeStreamListTransformColumn.js';
import { NativeStreamMapKeyType } from '../models/NativeStreamMapKeyType.js';
import { NativeStreamMapOutputField } from '../models/NativeStreamMapOutputField.js';
import { NativeStreamMapOutputType } from '../models/NativeStreamMapOutputType.js';
import { NativeStreamMapTransformColumn } from '../models/NativeStreamMapTransformColumn.js';
import { NativeStreamOutputField } from '../models/NativeStreamOutputField.js';
import { NativeStreamOutputType } from '../models/NativeStreamOutputType.js';
import { NativeStreamProbeFilterReport } from '../models/NativeStreamProbeFilterReport.js';
import { NativeStreamProbeIssue } from '../models/NativeStreamProbeIssue.js';
import { NativeStreamProbeSamplingReport } from '../models/NativeStreamProbeSamplingReport.js';
import { NativeStreamProfileSampleConfig } from '../models/NativeStreamProfileSampleConfig.js';
import { NativeStreamProperties } from '../models/NativeStreamProperties.js';
import { NativeStreamSamplingConfig } from '../models/NativeStreamSamplingConfig.js';
import { NativeStreamSamplingFeature } from '../models/NativeStreamSamplingFeature.js';
import { NativeStreamScalarOutputField } from '../models/NativeStreamScalarOutputField.js';
import { NativeStreamScalarOutputType } from '../models/NativeStreamScalarOutputType.js';
import { NativeStreamScalarTransformColumn } from '../models/NativeStreamScalarTransformColumn.js';
import { NativeStreamSchemaColumn } from '../models/NativeStreamSchemaColumn.js';
import { NativeStreamSchemaConfig } from '../models/NativeStreamSchemaConfig.js';
import { NativeStreamSpoolConfig } from '../models/NativeStreamSpoolConfig.js';
import { NativeStreamStatsConfig } from '../models/NativeStreamStatsConfig.js';
import { NativeStreamStructOutputField } from '../models/NativeStreamStructOutputField.js';
import { NativeStreamStructOutputType } from '../models/NativeStreamStructOutputType.js';
import { NativeStreamStructTransformColumn } from '../models/NativeStreamStructTransformColumn.js';
import { NativeStreamTransformColumn } from '../models/NativeStreamTransformColumn.js';
import { NativeStreamTransformConfig } from '../models/NativeStreamTransformConfig.js';
import { NativeStreamTransformProbeRequest } from '../models/NativeStreamTransformProbeRequest.js';
import { NativeStreamTransformProbeResponse } from '../models/NativeStreamTransformProbeResponse.js';
import { NativeStreamTransformUdf } from '../models/NativeStreamTransformUdf.js';
import { NativeStreamUpsertConfig } from '../models/NativeStreamUpsertConfig.js';
import { NativeStreamVariantShreddingConfig } from '../models/NativeStreamVariantShreddingConfig.js';
import { Notebook } from '../models/Notebook.js';
import { NotebookExecutionOutput } from '../models/NotebookExecutionOutput.js';
import { NotebookExecutionResult } from '../models/NotebookExecutionResult.js';
import { NotebookSession } from '../models/NotebookSession.js';
import { NotificationMessageMapping } from '../models/NotificationMessageMapping.js';
import { NumericDistribution } from '../models/NumericDistribution.js';
import { OverrideParseResult } from '../models/OverrideParseResult.js';
import { OverrideSampleExample } from '../models/OverrideSampleExample.js';
import { PageResponseEnvelope } from '../models/PageResponseEnvelope.js';
import { PaimonRestCatalogConfig } from '../models/PaimonRestCatalogConfig.js';
import { PaimonSinkProperties } from '../models/PaimonSinkProperties.js';
import { ParsedValue } from '../models/ParsedValue.js';
import { PartitionCandidate } from '../models/PartitionCandidate.js';
import { PartitionField } from '../models/PartitionField.js';
import { PatchIngestionPipelineInput } from '../models/PatchIngestionPipelineInput.js';
import { PathPartitionsTimestamp } from '../models/PathPartitionsTimestamp.js';
import { PathSegment } from '../models/PathSegment.js';
import { PipelineHistoryEntry } from '../models/PipelineHistoryEntry.js';
import { PipelineHistoryField } from '../models/PipelineHistoryField.js';
import { PipelineHistoryFieldChange } from '../models/PipelineHistoryFieldChange.js';
import { PipelineHistoryKindFilters } from '../models/PipelineHistoryKindFilters.js';
import { PipelineHistorySummary } from '../models/PipelineHistorySummary.js';
import { PodObservation } from '../models/PodObservation.js';
import { PollingConfig } from '../models/PollingConfig.js';
import { ProbeError } from '../models/ProbeError.js';
import { ProbeFailedResponse } from '../models/ProbeFailedResponse.js';
import { ProbeFailedResponseError } from '../models/ProbeFailedResponseError.js';
import { PscEndpoint } from '../models/PscEndpoint.js';
import { PutDraftFileInput } from '../models/PutDraftFileInput.js';
import { PutTableContextFileRequest } from '../models/PutTableContextFileRequest.js';
import { PutTableContextFileResponse } from '../models/PutTableContextFileResponse.js';
import { QuantilePoint } from '../models/QuantilePoint.js';
import { QuantileTrendSeries } from '../models/QuantileTrendSeries.js';
import { QuarantineBatch } from '../models/QuarantineBatch.js';
import { QuarantineSampleRow } from '../models/QuarantineSampleRow.js';
import { QuarantineSummary } from '../models/QuarantineSummary.js';
import { RepositoryAsset } from '../models/RepositoryAsset.js';
import { ResolvedRepositorySource } from '../models/ResolvedRepositorySource.js';
import { RewriteTableContextResponse } from '../models/RewriteTableContextResponse.js';
import { RunJobTemplateResponse } from '../models/RunJobTemplateResponse.js';
import { S3DetectPartitionsRequest } from '../models/S3DetectPartitionsRequest.js';
import { S3DetectPartitionsResponse } from '../models/S3DetectPartitionsResponse.js';
import { S3FileSampleStats } from '../models/S3FileSampleStats.js';
import { S3ListPrefixesRequest } from '../models/S3ListPrefixesRequest.js';
import { S3ListPrefixesResponse } from '../models/S3ListPrefixesResponse.js';
import { S3SampleFileRequest } from '../models/S3SampleFileRequest.js';
import { S3SampleFileResponse } from '../models/S3SampleFileResponse.js';
import { S3SampleObject } from '../models/S3SampleObject.js';
import { S3SourceProperties } from '../models/S3SourceProperties.js';
import { SamplingSimulationRequest } from '../models/SamplingSimulationRequest.js';
import { SamplingSimulationResponse } from '../models/SamplingSimulationResponse.js';
import { SamplingSimulationSegment } from '../models/SamplingSimulationSegment.js';
import { SamplingSimulationSubset } from '../models/SamplingSimulationSubset.js';
import { SaslSecretProbe } from '../models/SaslSecretProbe.js';
import { SaveNotebookContentRequest } from '../models/SaveNotebookContentRequest.js';
import { SavedQuery } from '../models/SavedQuery.js';
import { SchemaChangeEvent } from '../models/SchemaChangeEvent.js';
import { SchemaField } from '../models/SchemaField.js';
import { SchemaReference } from '../models/SchemaReference.js';
import { SchemaRegistryAuthConfig } from '../models/SchemaRegistryAuthConfig.js';
import { SchemaRegistryAuthConfigInput } from '../models/SchemaRegistryAuthConfigInput.js';
import { SchemaRegistryConfig } from '../models/SchemaRegistryConfig.js';
import { SchemaRegistryConfigInput } from '../models/SchemaRegistryConfigInput.js';
import { SchemaRegistryConnectRequest } from '../models/SchemaRegistryConnectRequest.js';
import { SchemaRegistryConnectResponse } from '../models/SchemaRegistryConnectResponse.js';
import { SchemaRegistryResolveSubjectRequest } from '../models/SchemaRegistryResolveSubjectRequest.js';
import { SchemaRegistryResolveSubjectResponse } from '../models/SchemaRegistryResolveSubjectResponse.js';
import { SchemaRegistrySchemaByIdRequest } from '../models/SchemaRegistrySchemaByIdRequest.js';
import { SchemaRegistrySchemaRequest } from '../models/SchemaRegistrySchemaRequest.js';
import { SchemaRegistrySchemaResponse } from '../models/SchemaRegistrySchemaResponse.js';
import { SchemaRegistrySubject } from '../models/SchemaRegistrySubject.js';
import { SchemaRegistrySubjectsRequest } from '../models/SchemaRegistrySubjectsRequest.js';
import { SchemaRegistrySubjectsResponse } from '../models/SchemaRegistrySubjectsResponse.js';
import { SecretRef } from '../models/SecretRef.js';
import { SecretRefAws } from '../models/SecretRefAws.js';
import { SecretRefGcp } from '../models/SecretRefGcp.js';
import { SecretRefInput } from '../models/SecretRefInput.js';
import { SecretRefInputAws } from '../models/SecretRefInputAws.js';
import { SecretRefInputGcp } from '../models/SecretRefInputGcp.js';
import { SecurityGroupRule } from '../models/SecurityGroupRule.js';
import { SemanticLayerBuildResponse } from '../models/SemanticLayerBuildResponse.js';
import { SendCommitterCommandRequest } from '../models/SendCommitterCommandRequest.js';
import { SendCommitterCommandResponse } from '../models/SendCommitterCommandResponse.js';
import { SortAggregationServingTokenBy } from '../models/SortAggregationServingTokenBy.js';
import { SortColumnSpec } from '../models/SortColumnSpec.js';
import { SortCredentialsProfileBy } from '../models/SortCredentialsProfileBy.js';
import { SortDashboardBy } from '../models/SortDashboardBy.js';
import { SortDataCatalogBy } from '../models/SortDataCatalogBy.js';
import { SortGitRepositoryBy } from '../models/SortGitRepositoryBy.js';
import { SortGraphBy } from '../models/SortGraphBy.js';
import { SortIngestionPartitionBy } from '../models/SortIngestionPartitionBy.js';
import { SortIngestionPipelineBy } from '../models/SortIngestionPipelineBy.js';
import { SortIngestionPipelineDeadLetterBy } from '../models/SortIngestionPipelineDeadLetterBy.js';
import { SortJobTemplateBy } from '../models/SortJobTemplateBy.js';
import { SortMaintenanceRunBy } from '../models/SortMaintenanceRunBy.js';
import { SortNotebookBy } from '../models/SortNotebookBy.js';
import { SortPipelineHistoryBy } from '../models/SortPipelineHistoryBy.js';
import { SortSavedQueryBy } from '../models/SortSavedQueryBy.js';
import { SortSparkEngineBy } from '../models/SortSparkEngineBy.js';
import { SortSparkJobBy } from '../models/SortSparkJobBy.js';
import { SortSqlEngineBy } from '../models/SortSqlEngineBy.js';
import { SortSqlQueryExecutionBy } from '../models/SortSqlQueryExecutionBy.js';
import { SortWorkspaceBy } from '../models/SortWorkspaceBy.js';
import { SortZeroEtlPolicyBy } from '../models/SortZeroEtlPolicyBy.js';
import { SourceShardByPathPartition } from '../models/SourceShardByPathPartition.js';
import { SparkEngine } from '../models/SparkEngine.js';
import { SparkEngineStatusFilters } from '../models/SparkEngineStatusFilters.js';
import { SparkJob } from '../models/SparkJob.js';
import { SparkJobRequestedSource } from '../models/SparkJobRequestedSource.js';
import { SparkJobResolvedSource } from '../models/SparkJobResolvedSource.js';
import { SparkJobRetryPolicy } from '../models/SparkJobRetryPolicy.js';
import { SparkJobSource } from '../models/SparkJobSource.js';
import { SparkJobSourceInput } from '../models/SparkJobSourceInput.js';
import { SparkJobSparkSubmitParams } from '../models/SparkJobSparkSubmitParams.js';
import { SparkJobStatusFilters } from '../models/SparkJobStatusFilters.js';
import { SparkJobStorageConfig } from '../models/SparkJobStorageConfig.js';
import { SqlEngine } from '../models/SqlEngine.js';
import { SqlEngineStatusFilters } from '../models/SqlEngineStatusFilters.js';
import { SqlQueryExecution } from '../models/SqlQueryExecution.js';
import { SqlQueryExecutionResult } from '../models/SqlQueryExecutionResult.js';
import { SqlQueryExecutionResultColumn } from '../models/SqlQueryExecutionResultColumn.js';
import { SqlQueryExecutionStatusFilters } from '../models/SqlQueryExecutionStatusFilters.js';
import { SqsQueuePolicyProbeError } from '../models/SqsQueuePolicyProbeError.js';
import { SqsQueuePolicyProbeRequest } from '../models/SqsQueuePolicyProbeRequest.js';
import { SqsQueuePolicyProbeResponse } from '../models/SqsQueuePolicyProbeResponse.js';
import { StartGitIntegrationAuthorizationInput } from '../models/StartGitIntegrationAuthorizationInput.js';
import { StartGitIntegrationAuthorizationResponse } from '../models/StartGitIntegrationAuthorizationResponse.js';
import { StartNotebookSessionInput } from '../models/StartNotebookSessionInput.js';
import { StartSparkJobDirectParams } from '../models/StartSparkJobDirectParams.js';
import { StartSparkJobDirectParamsSource } from '../models/StartSparkJobDirectParamsSource.js';
import { StartSparkJobInput } from '../models/StartSparkJobInput.js';
import { StartSparkJobTemplateParams } from '../models/StartSparkJobTemplateParams.js';
import { StartSqlQueryExecutionInput } from '../models/StartSqlQueryExecutionInput.js';
import { StatWidget } from '../models/StatWidget.js';
import { StateListItem } from '../models/StateListItem.js';
import { StateListWidget } from '../models/StateListWidget.js';
import { StorageConfig } from '../models/StorageConfig.js';
import { StreamCursorHalt } from '../models/StreamCursorHalt.js';
import { StreamCursorResetRequest } from '../models/StreamCursorResetRequest.js';
import { StringFilters } from '../models/StringFilters.js';
import { SubjectResolution } from '../models/SubjectResolution.js';
import { TableColumnProfile } from '../models/TableColumnProfile.js';
import { TableColumnStats } from '../models/TableColumnStats.js';
import { TableColumnTopValue } from '../models/TableColumnTopValue.js';
import { TableContextColumn } from '../models/TableContextColumn.js';
import { TableContextColumnEdit } from '../models/TableContextColumnEdit.js';
import { TableContextDecidedColumn } from '../models/TableContextDecidedColumn.js';
import { TableContextEdit } from '../models/TableContextEdit.js';
import { TableContextFile } from '../models/TableContextFile.js';
import { TableContextKind } from '../models/TableContextKind.js';
import { TableContextKindColumn } from '../models/TableContextKindColumn.js';
import { TableContextKindEdit } from '../models/TableContextKindEdit.js';
import { TableContextKinds } from '../models/TableContextKinds.js';
import { TableContextLeftOut } from '../models/TableContextLeftOut.js';
import { TableContextMetric } from '../models/TableContextMetric.js';
import { TableContextMetricEdit } from '../models/TableContextMetricEdit.js';
import { TableContextNewNote } from '../models/TableContextNewNote.js';
import { TableContextNote } from '../models/TableContextNote.js';
import { TableContextNoteEdit } from '../models/TableContextNoteEdit.js';
import { TableContextOverview } from '../models/TableContextOverview.js';
import { TableContextRejectedMetric } from '../models/TableContextRejectedMetric.js';
import { TableContextRelease } from '../models/TableContextRelease.js';
import { TableContextRewrite } from '../models/TableContextRewrite.js';
import { TableContextSameColumns } from '../models/TableContextSameColumns.js';
import { TableContextSegment } from '../models/TableContextSegment.js';
import { TableContextSegmentColumn } from '../models/TableContextSegmentColumn.js';
import { TableContextSegmentMap } from '../models/TableContextSegmentMap.js';
import { TableContextSegmentMapCell } from '../models/TableContextSegmentMapCell.js';
import { TableContextSegmentMapRow } from '../models/TableContextSegmentMapRow.js';
import { TableContextSegments } from '../models/TableContextSegments.js';
import { TableContextSummary } from '../models/TableContextSummary.js';
import { TableContextVersion } from '../models/TableContextVersion.js';
import { TableDataQualityPartitionRow } from '../models/TableDataQualityPartitionRow.js';
import { TableDataQualitySettings } from '../models/TableDataQualitySettings.js';
import { TableEventTimeBucket } from '../models/TableEventTimeBucket.js';
import { TableLiveView } from '../models/TableLiveView.js';
import { TableMaintenanceConfig } from '../models/TableMaintenanceConfig.js';
import { TableRetentionConfig } from '../models/TableRetentionConfig.js';
import { TableSampleCell } from '../models/TableSampleCell.js';
import { TableSignal } from '../models/TableSignal.js';
import { TableSourceProperties } from '../models/TableSourceProperties.js';
import { TableSourceStart } from '../models/TableSourceStart.js';
import { TableWidget } from '../models/TableWidget.js';
import { Threshold } from '../models/Threshold.js';
import { ThresholdStep } from '../models/ThresholdStep.js';
import { TimeseriesWidget } from '../models/TimeseriesWidget.js';
import { TlsSecretProbe } from '../models/TlsSecretProbe.js';
import { TriggeredAction } from '../models/TriggeredAction.js';
import { UpdateAwsPrivateLinkInput } from '../models/UpdateAwsPrivateLinkInput.js';
import { UpdateCredentialsProfileInput } from '../models/UpdateCredentialsProfileInput.js';
import { UpdateCredentialsProfileInputAws } from '../models/UpdateCredentialsProfileInputAws.js';
import { UpdateCredentialsProfileInputGcp } from '../models/UpdateCredentialsProfileInputGcp.js';
import { UpdateDashboardInput } from '../models/UpdateDashboardInput.js';
import { UpdateGraphInput } from '../models/UpdateGraphInput.js';
import { UpdateIngestionPipelineInput } from '../models/UpdateIngestionPipelineInput.js';
import { UpdateJobTemplateInput } from '../models/UpdateJobTemplateInput.js';
import { UpdateMetricExportDestinationInput } from '../models/UpdateMetricExportDestinationInput.js';
import { UpdateMetricExportDestinationInputSecretRef } from '../models/UpdateMetricExportDestinationInputSecretRef.js';
import { UpdateNotebookInput } from '../models/UpdateNotebookInput.js';
import { UpdatePscEndpointInput } from '../models/UpdatePscEndpointInput.js';
import { UpdateSavedQueryInput } from '../models/UpdateSavedQueryInput.js';
import { UpdateTableContextRequest } from '../models/UpdateTableContextRequest.js';
import { UpdateTableContextResponse } from '../models/UpdateTableContextResponse.js';
import { UpdateTableDataQualitySettingsRequest } from '../models/UpdateTableDataQualitySettingsRequest.js';
import { UpdateTableMaintenanceConfigInput } from '../models/UpdateTableMaintenanceConfigInput.js';
import { UpdateWorkspaceLoggingSettingsInput } from '../models/UpdateWorkspaceLoggingSettingsInput.js';
import { UpdateWorkspaceLoggingSettingsInputAws } from '../models/UpdateWorkspaceLoggingSettingsInputAws.js';
import { UpdateWorkspaceLoggingSettingsInputGcp } from '../models/UpdateWorkspaceLoggingSettingsInputGcp.js';
import { UpdateWorkspaceMaintenanceSettingsRequest } from '../models/UpdateWorkspaceMaintenanceSettingsRequest.js';
import { UpdateWorkspaceMetricsSettingsInput } from '../models/UpdateWorkspaceMetricsSettingsInput.js';
import { UpdateWorkspaceMetricsSettingsInputAws } from '../models/UpdateWorkspaceMetricsSettingsInputAws.js';
import { UpdateWorkspaceMetricsSettingsInputGcp } from '../models/UpdateWorkspaceMetricsSettingsInputGcp.js';
import { UpdateWorkspaceStorageAccessConfigurationInput } from '../models/UpdateWorkspaceStorageAccessConfigurationInput.js';
import { UpdateWorkspaceStorageAccessConfigurationInputAws } from '../models/UpdateWorkspaceStorageAccessConfigurationInputAws.js';
import { UpdateWorkspaceStorageAccessConfigurationInputGcp } from '../models/UpdateWorkspaceStorageAccessConfigurationInputGcp.js';
import { UpdateZeroEtlPolicyInput } from '../models/UpdateZeroEtlPolicyInput.js';
import { ValueMapping } from '../models/ValueMapping.js';
import { ValueMappingResult } from '../models/ValueMappingResult.js';
import { WarmCapacity } from '../models/WarmCapacity.js';
import { Widget } from '../models/Widget.js';
import { WidgetLayout } from '../models/WidgetLayout.js';
import { WidgetTableCell } from '../models/WidgetTableCell.js';
import { WidgetTableColumn } from '../models/WidgetTableColumn.js';
import { WidgetTableRow } from '../models/WidgetTableRow.js';
import { Workspace } from '../models/Workspace.js';
import { WorkspaceAllowedPrincipal } from '../models/WorkspaceAllowedPrincipal.js';
import { WorkspaceAllowedPrincipalInput } from '../models/WorkspaceAllowedPrincipalInput.js';
import { WorkspaceAws } from '../models/WorkspaceAws.js';
import { WorkspaceAwsStorageAccessConfiguration } from '../models/WorkspaceAwsStorageAccessConfiguration.js';
import { WorkspaceGcp } from '../models/WorkspaceGcp.js';
import { WorkspaceGcpStorageAccessConfiguration } from '../models/WorkspaceGcpStorageAccessConfiguration.js';
import { WorkspaceLoggingSettings } from '../models/WorkspaceLoggingSettings.js';
import { WorkspaceLoggingSettingsAws } from '../models/WorkspaceLoggingSettingsAws.js';
import { WorkspaceLoggingSettingsGcp } from '../models/WorkspaceLoggingSettingsGcp.js';
import { WorkspaceMaintenanceSettings } from '../models/WorkspaceMaintenanceSettings.js';
import { WorkspaceMetricsSettings } from '../models/WorkspaceMetricsSettings.js';
import { WorkspaceMetricsSettingsAws } from '../models/WorkspaceMetricsSettingsAws.js';
import { WorkspaceMetricsSettingsGcp } from '../models/WorkspaceMetricsSettingsGcp.js';
import { WorkspaceNetworkingSettings } from '../models/WorkspaceNetworkingSettings.js';
import { WorkspaceNetworkingSettingsAws } from '../models/WorkspaceNetworkingSettingsAws.js';
import { WorkspaceNetworkingSettingsGcp } from '../models/WorkspaceNetworkingSettingsGcp.js';
import { WorkspaceStatusFilters } from '../models/WorkspaceStatusFilters.js';
import { WorkspaceStorageAccessConfiguration } from '../models/WorkspaceStorageAccessConfiguration.js';
import { WorkspaceStorageAccessConfigurationAws } from '../models/WorkspaceStorageAccessConfigurationAws.js';
import { WorkspaceStorageAccessConfigurationGcp } from '../models/WorkspaceStorageAccessConfigurationGcp.js';
import { WorkspaceStorageAllowedCredentialsProfile } from '../models/WorkspaceStorageAllowedCredentialsProfile.js';
import { WorkspaceStorageAllowedCredentialsProfileInput } from '../models/WorkspaceStorageAllowedCredentialsProfileInput.js';
import { ZeroEtlIdentityColumnSpec } from '../models/ZeroEtlIdentityColumnSpec.js';
import { ZeroEtlPolicy } from '../models/ZeroEtlPolicy.js';
import { ZeroEtlResourceSelector } from '../models/ZeroEtlResourceSelector.js';
import { ZeroEtlRoutingPolicy } from '../models/ZeroEtlRoutingPolicy.js';
let primitives = [
    "string",
    "boolean",
    "double",
    "integer",
    "long",
    "float",
    "number",
    "any"
];
let enumsMap = new Set([
    "AggregationServingTokenSortField",
    "AlertChannelKind",
    "BatchMode",
    "BiglakeCatalogMode",
    "BucketFileCompression",
    "BucketFileFormat",
    "BucketFileProbeRequestCloudEnum",
    "BucketFilesMode",
    "BucketNotificationTransport",
    "CatalogOwner",
    "ChangeOp",
    "ColumnRole",
    "CommitterCommand",
    "CompactionStrategy",
    "CreateGraphInputChartTypeEnum",
    "CreateSqlEngineInputWorkerSizeEnum",
    "CredentialsProfileSortField",
    "DashboardGraphChartTypeEnum",
    "DashboardSortField",
    "DataCatalogSortField",
    "DataCatalogType",
    "DetectedFormatType",
    "DiffChangeType",
    "DistributionKind",
    "EonSparkVersion",
    "ErrorPolicy",
    "FieldOverrideOnError",
    "FieldOverrideTargetType",
    "FileFormat",
    "FileReadOnlyReason",
    "GitAccountType",
    "GitIntegrationStatus",
    "GitProvider",
    "GitRepositorySortField",
    "GitRepositoryStatus",
    "GraphSortField",
    "HealthStatus",
    "IcebergRestCatalogAuthType",
    "IngestionComputeSize",
    "IngestionPartitionSortField",
    "IngestionPartitionStatus",
    "IngestionPipelineDeadLetterSortField",
    "IngestionPipelineErrorLevel",
    "IngestionPipelineErrorSource",
    "IngestionPipelineHealth",
    "IngestionPipelineIssueSeverity",
    "IngestionPipelineRetiredAggregationPhase",
    "IngestionPipelineSortField",
    "IngestionPipelineStatus",
    "IngestionRuntime",
    "IngestionSinkType",
    "IngestionSourceType",
    "JobTemplateSortField",
    "KafkaKeyHandling",
    "KafkaMessageFormat",
    "KafkaOffsetStrategy",
    "KafkaSaslMechanism",
    "KafkaSecurityProtocol",
    "KafkaStartingOffset",
    "LooksLike",
    "MaintenanceMetricUnit",
    "MaintenanceRunSortField",
    "MaintenanceRunStatus",
    "MaintenanceRunType",
    "MergeState",
    "MetricExportDestinationType",
    "NativeStreamAggregationEntryLookback",
    "NativeStreamAggregationPlacement",
    "NativeStreamAggregationServingFreshness",
    "NativeStreamBloomFilterWriteMode",
    "NativeStreamCastOverflowAction",
    "NativeStreamClusterCurve",
    "NativeStreamKeyIndexScope",
    "NativeStreamListOutputKind",
    "NativeStreamMapOutputKind",
    "NativeStreamNewColumnPolicy",
    "NativeStreamRole",
    "NativeStreamScalarOutputKind",
    "NativeStreamScalarTransformKind",
    "NativeStreamSchemaColumnType",
    "NativeStreamStatKind",
    "NativeStreamStructOutputKind",
    "NativeStreamUntrackedAction",
    "NativeStreamWeightMode",
    "NotebookExecutionOutputTypeEnum",
    "NotebookExecutionResultStatusEnum",
    "NotebookSessionStatus",
    "NotebookSortField",
    "PaimonClusteringStrategy",
    "PaimonRestAuthMode",
    "PartitionFormat",
    "PartitionSegmentType",
    "PartitionTransform",
    "PartitionType",
    "PathPartitionsTimestampGranularity",
    "PipelineHistoryFieldKind",
    "PipelineHistoryKind",
    "PipelineHistorySortField",
    "PipelineHistorySortOrder",
    "PipelineRuntimeStopReason",
    "PrivateLinkStatus",
    "ProbeErrorCode",
    "RemovalPolicy",
    "RepositoryAssetType",
    "RepositoryRef",
    "S3PartitionLayout",
    "SavedQuerySortField",
    "SchemaChangeKind",
    "SchemaEvolutionMode",
    "SchemaRegistryAuthType",
    "SecurityGroupRuleProtocol",
    "SegmentType",
    "SortColumnSpecDirectionEnum",
    "SortOrder",
    "SparkEngineSortField",
    "SparkEngineStatus",
    "SparkJobSortField",
    "SparkJobSourceType",
    "SparkJobStatus",
    "SqlEngineSortField",
    "SqlEngineStatus",
    "SqlEngineType",
    "SqlQueryExecutionSortField",
    "SqlQueryExecutionStatus",
    "SqsQueuePolicyProbeStatus",
    "StreamCursorResetRequestToEnum",
    "SubjectNamingStrategy",
    "TableContextColumnUse",
    "TableContextRewriteState",
    "TableContextSegmentColumnDecision",
    "TableContextSegmentMark",
    "TableContextVersionReason",
    "TableFormat",
    "TableSignalKind",
    "TableSourceStartKind",
    "TelemetryExportApplyStatus",
    "TelemetryExportAuthMode",
    "TelemetryExportOtlpProtocol",
    "ThresholdMode",
    "TimeseriesChartKind",
    "TreeEntryType",
    "UnsupportedSnapshotPolicy",
    "UpdateGraphInputChartTypeEnum",
    "ValueMappingType",
    "VpcPeeringStatus",
    "WidgetTableColumnAlignEnum",
    "WidgetType",
    "WorkspaceSortField",
    "WorkspaceStatus",
    "WorkspaceStoragePermission",
    "ZeroEtlIdentityColumnField",
    "ZeroEtlPolicySortField",
    "ZeroEtlRoutingMode",
]);
let typeMap = {
    "AggregationServingToken": AggregationServingToken,
    "AlertChannel": AlertChannel,
    "AnalyzeSqlQueryRequest": AnalyzeSqlQueryRequest,
    "AvailableRepository": AvailableRepository,
    "AwsCredentialProfile": AwsCredentialProfile,
    "AwsCredentialProfileInput": AwsCredentialProfileInput,
    "AwsLoggingSettings": AwsLoggingSettings,
    "AwsLoggingSettingsInput": AwsLoggingSettingsInput,
    "AwsMetricsSettings": AwsMetricsSettings,
    "AwsMetricsSettingsInput": AwsMetricsSettingsInput,
    "AwsNetworkingSettings": AwsNetworkingSettings,
    "AwsNetworkingSettingsVpcPeering": AwsNetworkingSettingsVpcPeering,
    "AwsPrincipal": AwsPrincipal,
    "AwsPrincipalInput": AwsPrincipalInput,
    "AwsPrivateLink": AwsPrivateLink,
    "AwsSecretsManagerRef": AwsSecretsManagerRef,
    "AwsSecretsManagerRefInput": AwsSecretsManagerRefInput,
    "AwsStorageAccessConfigurationInput": AwsStorageAccessConfigurationInput,
    "AwsVpcPeering": AwsVpcPeering,
    "AwsWorkspaceInfo": AwsWorkspaceInfo,
    "BatchDraftCommitInput": BatchDraftCommitInput,
    "BatchGetAggregationRowsRequest": BatchGetAggregationRowsRequest,
    "BatchGetAggregationRowsResponse": BatchGetAggregationRowsResponse,
    "BatchIngestionPipelineMetricsRangeRequest": BatchIngestionPipelineMetricsRangeRequest,
    "BatchIngestionPipelineMetricsRangeResponse": BatchIngestionPipelineMetricsRangeResponse,
    "BatchIngestionPipelineMetricsRequest": BatchIngestionPipelineMetricsRequest,
    "BatchIngestionPipelineMetricsResponse": BatchIngestionPipelineMetricsResponse,
    "BiglakeCatalogProperties": BiglakeCatalogProperties,
    "BooleanFilters": BooleanFilters,
    "BucketFileProbeRequest": BucketFileProbeRequest,
    "BucketFileProbeResponse": BucketFileProbeResponse,
    "BucketFilesSourceProperties": BucketFilesSourceProperties,
    "BucketNotificationProbeRequest": BucketNotificationProbeRequest,
    "BucketNotificationProbeResponse": BucketNotificationProbeResponse,
    "BucketPathPartitionSpec": BucketPathPartitionSpec,
    "CatalogAccessRequest": CatalogAccessRequest,
    "CatalogAccessResponse": CatalogAccessResponse,
    "CatalogCheckNameRequest": CatalogCheckNameRequest,
    "CatalogCheckNameResponse": CatalogCheckNameResponse,
    "CatalogDatabase": CatalogDatabase,
    "CatalogListDatabasesRequest": CatalogListDatabasesRequest,
    "CatalogListDatabasesResponse": CatalogListDatabasesResponse,
    "CategoryTrendSeries": CategoryTrendSeries,
    "CloudPrincipal": CloudPrincipal,
    "CloudPrincipalAws": CloudPrincipalAws,
    "CloudPrincipalGcp": CloudPrincipalGcp,
    "CloudPrincipalInput": CloudPrincipalInput,
    "CloudPrincipalInputAws": CloudPrincipalInputAws,
    "CloudPrincipalInputGcp": CloudPrincipalInputGcp,
    "ColumnNullRate": ColumnNullRate,
    "CommitChangeInput": CommitChangeInput,
    "CommitterCompactionStrategyStats": CommitterCompactionStrategyStats,
    "CommitterMaintenanceStats": CommitterMaintenanceStats,
    "CommitterSealCompactionStats": CommitterSealCompactionStats,
    "CompleteGitIntegrationInput": CompleteGitIntegrationInput,
    "Condition": Condition,
    "ConnectGitRepositoryInput": ConnectGitRepositoryInput,
    "CreateAggregationServingTokenRequest": CreateAggregationServingTokenRequest,
    "CreateAggregationServingTokenResponse": CreateAggregationServingTokenResponse,
    "CreateAwsPrivateLinkInput": CreateAwsPrivateLinkInput,
    "CreateAwsVpcPeeringInput": CreateAwsVpcPeeringInput,
    "CreateCredentialsProfileInput": CreateCredentialsProfileInput,
    "CreateDashboardInput": CreateDashboardInput,
    "CreateDataCatalogInput": CreateDataCatalogInput,
    "CreateDataCatalogInputGlueProperties": CreateDataCatalogInputGlueProperties,
    "CreateDataCatalogInputIcebergRestProperties": CreateDataCatalogInputIcebergRestProperties,
    "CreateGcpVpcPeeringInput": CreateGcpVpcPeeringInput,
    "CreateGraphInput": CreateGraphInput,
    "CreateIngestionPipelineInput": CreateIngestionPipelineInput,
    "CreateJobTemplateInput": CreateJobTemplateInput,
    "CreateNotebookInput": CreateNotebookInput,
    "CreatePscEndpointInput": CreatePscEndpointInput,
    "CreatePullRequestInput": CreatePullRequestInput,
    "CreateSavedQueryInput": CreateSavedQueryInput,
    "CreateSparkEngineInput": CreateSparkEngineInput,
    "CreateSqlEngineInput": CreateSqlEngineInput,
    "CreateZeroEtlPolicyInput": CreateZeroEtlPolicyInput,
    "CredentialsProbeAssumeResponse": CredentialsProbeAssumeResponse,
    "CredentialsProbeWriteResponse": CredentialsProbeWriteResponse,
    "CredentialsProfile": CredentialsProfile,
    "CredentialsProfileAws": CredentialsProfileAws,
    "CredentialsProfileGcp": CredentialsProfileGcp,
    "CriticalColumnSlo": CriticalColumnSlo,
    "CsvOptions": CsvOptions,
    "Dashboard": Dashboard,
    "DashboardGraph": DashboardGraph,
    "DashboardGraphLayout": DashboardGraphLayout,
    "DashboardWithGraphs": DashboardWithGraphs,
    "DataCatalog": DataCatalog,
    "DataCatalogBiglakeProperties": DataCatalogBiglakeProperties,
    "DataCatalogGlueProperties": DataCatalogGlueProperties,
    "DataCatalogIcebergRestProperties": DataCatalogIcebergRestProperties,
    "DataCatalogTypeFilters": DataCatalogTypeFilters,
    "DataQualityAlertRouting": DataQualityAlertRouting,
    "DataQualityDashboard": DataQualityDashboard,
    "DataQualityDashboardSection": DataQualityDashboardSection,
    "DataQualityHeadlineKpi": DataQualityHeadlineKpi,
    "DataQualityHealthTrendSignal": DataQualityHealthTrendSignal,
    "DataQualityNavStatus": DataQualityNavStatus,
    "DataQualityTableMeta": DataQualityTableMeta,
    "DateRangeFilter": DateRangeFilter,
    "DetectedFormat": DetectedFormat,
    "DistributionBucket": DistributionBucket,
    "DistributionColumn": DistributionColumn,
    "DistributionTrend": DistributionTrend,
    "DistributionTrendDistinct": DistributionTrendDistinct,
    "EnumCategoryShare": EnumCategoryShare,
    "EnumDistribution": EnumDistribution,
    "ExecuteNotebookCodeInput": ExecuteNotebookCodeInput,
    "FieldConfig": FieldConfig,
    "FieldOverride": FieldOverride,
    "FlinkDeploymentObservation": FlinkDeploymentObservation,
    "GaussianFit": GaussianFit,
    "GcpCredentialProfile": GcpCredentialProfile,
    "GcpCredentialProfileInput": GcpCredentialProfileInput,
    "GcpLoggingSettings": GcpLoggingSettings,
    "GcpLoggingSettingsInput": GcpLoggingSettingsInput,
    "GcpMetricsSettings": GcpMetricsSettings,
    "GcpMetricsSettingsInput": GcpMetricsSettingsInput,
    "GcpNetworkingSettings": GcpNetworkingSettings,
    "GcpNetworkingSettingsVpcPeering": GcpNetworkingSettingsVpcPeering,
    "GcpPrincipal": GcpPrincipal,
    "GcpPrincipalInput": GcpPrincipalInput,
    "GcpSecretManagerRef": GcpSecretManagerRef,
    "GcpSecretManagerRefInput": GcpSecretManagerRefInput,
    "GcpStorageAccessConfigurationInput": GcpStorageAccessConfigurationInput,
    "GcpVpcPeering": GcpVpcPeering,
    "GcpWorkspaceInfo": GcpWorkspaceInfo,
    "GcsListPrefixesRequest": GcsListPrefixesRequest,
    "GcsListPrefixesResponse": GcsListPrefixesResponse,
    "GcsSampleObject": GcsSampleObject,
    "GcsSourceProperties": GcsSourceProperties,
    "GetIngestionPipelineErrorsResponse": GetIngestionPipelineErrorsResponse,
    "GetIngestionPipelineSchemaResponse": GetIngestionPipelineSchemaResponse,
    "GetIngestionPipelineSpendLedgerResponse": GetIngestionPipelineSpendLedgerResponse,
    "GetNotebookContent200Response": GetNotebookContent200Response,
    "GetStreamCursorHaltsResponse": GetStreamCursorHaltsResponse,
    "GetTableContextFileResponse": GetTableContextFileResponse,
    "GetTableContextResponse": GetTableContextResponse,
    "GetTableContextRewriteResponse": GetTableContextRewriteResponse,
    "GetTableDataQualityColumnInspectResponse": GetTableDataQualityColumnInspectResponse,
    "GetTableDataQualityCompletenessResponse": GetTableDataQualityCompletenessResponse,
    "GetTableDataQualityDistributionColumnResponse": GetTableDataQualityDistributionColumnResponse,
    "GetTableDataQualityDistributionResponse": GetTableDataQualityDistributionResponse,
    "GetTableDataQualityEventTimeHistogramResponse": GetTableDataQualityEventTimeHistogramResponse,
    "GetTableDataQualityHeaderResponse": GetTableDataQualityHeaderResponse,
    "GetTableDataQualityHealthTrendResponse": GetTableDataQualityHealthTrendResponse,
    "GetTableDataQualityOverviewResponse": GetTableDataQualityOverviewResponse,
    "GetTableDataQualityPartitionsResponse": GetTableDataQualityPartitionsResponse,
    "GetTableDataQualityProfileResponse": GetTableDataQualityProfileResponse,
    "GetTableDataQualityQuarantineBatchResponse": GetTableDataQualityQuarantineBatchResponse,
    "GetTableDataQualityQuarantineResponse": GetTableDataQualityQuarantineResponse,
    "GetTableDataQualitySchemaChangesResponse": GetTableDataQualitySchemaChangesResponse,
    "GetTableDataQualitySettingsResponse": GetTableDataQualitySettingsResponse,
    "GetTableDataQualityWidgetSeriesResponse": GetTableDataQualityWidgetSeriesResponse,
    "GetTableSampleResponse": GetTableSampleResponse,
    "GetTableSignalsResponse": GetTableSignalsResponse,
    "GetTableSnapshotsResponse": GetTableSnapshotsResponse,
    "GitCommitResult": GitCommitResult,
    "GitDiffEntry": GitDiffEntry,
    "GitDiffResponse": GitDiffResponse,
    "GitDraft": GitDraft,
    "GitDraftPullRequest": GitDraftPullRequest,
    "GitFileResponse": GitFileResponse,
    "GitIntegration": GitIntegration,
    "GitMergeResult": GitMergeResult,
    "GitProviderFilters": GitProviderFilters,
    "GitPullRequest": GitPullRequest,
    "GitRepository": GitRepository,
    "GitRepositoryStatusFilters": GitRepositoryStatusFilters,
    "GitTreeEntry": GitTreeEntry,
    "GitTreeResponse": GitTreeResponse,
    "GlueCatalogProperties": GlueCatalogProperties,
    "GlueCatalogPropertiesInput": GlueCatalogPropertiesInput,
    "IcebergCompactionConfig": IcebergCompactionConfig,
    "IcebergRestCatalogProperties": IcebergRestCatalogProperties,
    "IcebergRestCatalogPropertiesCredentialsSecret": IcebergRestCatalogPropertiesCredentialsSecret,
    "IcebergRestCatalogPropertiesInput": IcebergRestCatalogPropertiesInput,
    "IcebergRestCatalogPropertiesInputCredentialsSecret": IcebergRestCatalogPropertiesInputCredentialsSecret,
    "IcebergSinkProperties": IcebergSinkProperties,
    "IcebergSnapshotEntry": IcebergSnapshotEntry,
    "IcebergTableColumn": IcebergTableColumn,
    "IdFilters": IdFilters,
    "IngestionPartition": IngestionPartition,
    "IngestionPartitionStatusFilters": IngestionPartitionStatusFilters,
    "IngestionPipeline": IngestionPipeline,
    "IngestionPipelineAggregationMetrics": IngestionPipelineAggregationMetrics,
    "IngestionPipelineDeadLetter": IngestionPipelineDeadLetter,
    "IngestionPipelineDeadLetterByteRange": IngestionPipelineDeadLetterByteRange,
    "IngestionPipelineDeadLetterErrorGroup": IngestionPipelineDeadLetterErrorGroup,
    "IngestionPipelineDeadLetterSummary": IngestionPipelineDeadLetterSummary,
    "IngestionPipelineErrorClass": IngestionPipelineErrorClass,
    "IngestionPipelineIssue": IngestionPipelineIssue,
    "IngestionPipelineLastObservation": IngestionPipelineLastObservation,
    "IngestionPipelineMetrics": IngestionPipelineMetrics,
    "IngestionPipelineMetricsRange": IngestionPipelineMetricsRange,
    "IngestionPipelineObservation": IngestionPipelineObservation,
    "IngestionPipelineObservationFlinkDeployment": IngestionPipelineObservationFlinkDeployment,
    "IngestionPipelinePurgeMetrics": IngestionPipelinePurgeMetrics,
    "IngestionPipelineRetiredAggregation": IngestionPipelineRetiredAggregation,
    "IngestionPipelineSpendLedgerRow": IngestionPipelineSpendLedgerRow,
    "IngestionPipelineStatusFilters": IngestionPipelineStatusFilters,
    "IngestionPipelineTag": IngestionPipelineTag,
    "JobTemplate": JobTemplate,
    "JobTemplateRetryPolicy": JobTemplateRetryPolicy,
    "JobTemplateSchedule": JobTemplateSchedule,
    "JobTemplateScheduleInput": JobTemplateScheduleInput,
    "JsonPathSample": JsonPathSample,
    "K8sEventObservation": K8sEventObservation,
    "KafkaBatchConfig": KafkaBatchConfig,
    "KafkaConnectProbeRequest": KafkaConnectProbeRequest,
    "KafkaConnectProbeResponse": KafkaConnectProbeResponse,
    "KafkaErrorHandlingConfig": KafkaErrorHandlingConfig,
    "KafkaInferSchemaRequest": KafkaInferSchemaRequest,
    "KafkaInferSchemaResponse": KafkaInferSchemaResponse,
    "KafkaMessageSample": KafkaMessageSample,
    "KafkaPartitioningConfig": KafkaPartitioningConfig,
    "KafkaSampleProbeRequest": KafkaSampleProbeRequest,
    "KafkaSampleProbeResponse": KafkaSampleProbeResponse,
    "KafkaSchemaOverridesConfig": KafkaSchemaOverridesConfig,
    "KafkaSecretProbeRequest": KafkaSecretProbeRequest,
    "KafkaSecretProbeResponse": KafkaSecretProbeResponse,
    "KafkaSecurityConfig": KafkaSecurityConfig,
    "KafkaSecurityConfigCredentialsSecret": KafkaSecurityConfigCredentialsSecret,
    "KafkaSecurityConfigInput": KafkaSecurityConfigInput,
    "KafkaSecurityConfigInputCredentialsSecret": KafkaSecurityConfigInputCredentialsSecret,
    "KafkaSecurityConfigInputTlsSecret": KafkaSecurityConfigInputTlsSecret,
    "KafkaSecurityConfigTlsSecret": KafkaSecurityConfigTlsSecret,
    "KafkaSourceConfig": KafkaSourceConfig,
    "KafkaSourceProperties": KafkaSourceProperties,
    "KafkaSourcePropertiesInput": KafkaSourcePropertiesInput,
    "KafkaTopicInfo": KafkaTopicInfo,
    "KafkaTopicPartition": KafkaTopicPartition,
    "KafkaTopicsProbeRequest": KafkaTopicsProbeRequest,
    "KafkaTopicsProbeResponse": KafkaTopicsProbeResponse,
    "ListAggregationServingTokensFilterConditions": ListAggregationServingTokensFilterConditions,
    "ListAggregationServingTokensRequest": ListAggregationServingTokensRequest,
    "ListAggregationServingTokensResponse": ListAggregationServingTokensResponse,
    "ListAvailableRepositoriesResponse": ListAvailableRepositoriesResponse,
    "ListCredentialsProfilesFilterConditions": ListCredentialsProfilesFilterConditions,
    "ListCredentialsProfilesRequest": ListCredentialsProfilesRequest,
    "ListCredentialsProfilesResponse": ListCredentialsProfilesResponse,
    "ListDashboardsFilterConditions": ListDashboardsFilterConditions,
    "ListDashboardsRequest": ListDashboardsRequest,
    "ListDashboardsResponse": ListDashboardsResponse,
    "ListDataCatalogsFilterConditions": ListDataCatalogsFilterConditions,
    "ListDataCatalogsRequest": ListDataCatalogsRequest,
    "ListDataCatalogsResponse": ListDataCatalogsResponse,
    "ListGitIntegrationsResponse": ListGitIntegrationsResponse,
    "ListGitRepositoriesFilterConditions": ListGitRepositoriesFilterConditions,
    "ListGitRepositoriesRequest": ListGitRepositoriesRequest,
    "ListGitRepositoriesResponse": ListGitRepositoriesResponse,
    "ListGraphsFilterConditions": ListGraphsFilterConditions,
    "ListGraphsRequest": ListGraphsRequest,
    "ListGraphsResponse": ListGraphsResponse,
    "ListIngestionPipelineDeadLettersRequest": ListIngestionPipelineDeadLettersRequest,
    "ListIngestionPipelineDeadLettersResponse": ListIngestionPipelineDeadLettersResponse,
    "ListIngestionPipelineHistoryFilterConditions": ListIngestionPipelineHistoryFilterConditions,
    "ListIngestionPipelineHistoryRequest": ListIngestionPipelineHistoryRequest,
    "ListIngestionPipelineHistoryResponse": ListIngestionPipelineHistoryResponse,
    "ListIngestionPipelinePartitionsFilterConditions": ListIngestionPipelinePartitionsFilterConditions,
    "ListIngestionPipelinePartitionsRequest": ListIngestionPipelinePartitionsRequest,
    "ListIngestionPipelinePartitionsResponse": ListIngestionPipelinePartitionsResponse,
    "ListIngestionPipelineTagsResponse": ListIngestionPipelineTagsResponse,
    "ListIngestionPipelinesFilterConditions": ListIngestionPipelinesFilterConditions,
    "ListIngestionPipelinesRequest": ListIngestionPipelinesRequest,
    "ListIngestionPipelinesResponse": ListIngestionPipelinesResponse,
    "ListJobTemplatesFilterConditions": ListJobTemplatesFilterConditions,
    "ListJobTemplatesRequest": ListJobTemplatesRequest,
    "ListJobTemplatesResponse": ListJobTemplatesResponse,
    "ListMaintenanceRunsFilterConditions": ListMaintenanceRunsFilterConditions,
    "ListMaintenanceRunsRequest": ListMaintenanceRunsRequest,
    "ListMaintenanceRunsResponse": ListMaintenanceRunsResponse,
    "ListNotebooksFilterConditions": ListNotebooksFilterConditions,
    "ListNotebooksRequest": ListNotebooksRequest,
    "ListNotebooksResponse": ListNotebooksResponse,
    "ListRepositoryAssetsResponse": ListRepositoryAssetsResponse,
    "ListSavedQueriesFilterConditions": ListSavedQueriesFilterConditions,
    "ListSavedQueriesRequest": ListSavedQueriesRequest,
    "ListSavedQueriesResponse": ListSavedQueriesResponse,
    "ListSparkEnginesFilterConditions": ListSparkEnginesFilterConditions,
    "ListSparkEnginesRequest": ListSparkEnginesRequest,
    "ListSparkEnginesResponse": ListSparkEnginesResponse,
    "ListSparkJobsFilterConditions": ListSparkJobsFilterConditions,
    "ListSparkJobsRequest": ListSparkJobsRequest,
    "ListSparkJobsResponse": ListSparkJobsResponse,
    "ListSqlEnginesFilterConditions": ListSqlEnginesFilterConditions,
    "ListSqlEnginesRequest": ListSqlEnginesRequest,
    "ListSqlEnginesResponse": ListSqlEnginesResponse,
    "ListSqlQueryExecutionsFilterConditions": ListSqlQueryExecutionsFilterConditions,
    "ListSqlQueryExecutionsRequest": ListSqlQueryExecutionsRequest,
    "ListSqlQueryExecutionsResponse": ListSqlQueryExecutionsResponse,
    "ListTableContextFilesResponse": ListTableContextFilesResponse,
    "ListTableContextVersionsResponse": ListTableContextVersionsResponse,
    "ListTableContextsResponse": ListTableContextsResponse,
    "ListTableMaintenanceRunsFilterConditions": ListTableMaintenanceRunsFilterConditions,
    "ListTableMaintenanceRunsRequest": ListTableMaintenanceRunsRequest,
    "ListTableMaintenanceRunsResponse": ListTableMaintenanceRunsResponse,
    "ListWorkspacesFilterConditions": ListWorkspacesFilterConditions,
    "ListWorkspacesRequest": ListWorkspacesRequest,
    "ListWorkspacesResponse": ListWorkspacesResponse,
    "ListZeroEtlPoliciesFilterConditions": ListZeroEtlPoliciesFilterConditions,
    "ListZeroEtlPoliciesRequest": ListZeroEtlPoliciesRequest,
    "ListZeroEtlPoliciesResponse": ListZeroEtlPoliciesResponse,
    "MaintenanceMetric": MaintenanceMetric,
    "MaintenanceRun": MaintenanceRun,
    "MaintenanceRunStatusFilters": MaintenanceRunStatusFilters,
    "MaintenanceRunTypeFilters": MaintenanceRunTypeFilters,
    "MetricExportDestination": MetricExportDestination,
    "MetricExportDestinationSecretRef": MetricExportDestinationSecretRef,
    "MetricTimeseries": MetricTimeseries,
    "MetricTimeseriesPoint": MetricTimeseriesPoint,
    "MoveDraftFileInput": MoveDraftFileInput,
    "NativeStreamAggregationConfig": NativeStreamAggregationConfig,
    "NativeStreamAggregationDerivedColumn": NativeStreamAggregationDerivedColumn,
    "NativeStreamAggregationEntryMetric": NativeStreamAggregationEntryMetric,
    "NativeStreamAggregationEntryRule": NativeStreamAggregationEntryRule,
    "NativeStreamAggregationMetric": NativeStreamAggregationMetric,
    "NativeStreamAggregationServing": NativeStreamAggregationServing,
    "NativeStreamAggregationSubMetric": NativeStreamAggregationSubMetric,
    "NativeStreamDedupConfig": NativeStreamDedupConfig,
    "NativeStreamEventTimeShiftConfig": NativeStreamEventTimeShiftConfig,
    "NativeStreamListOutputField": NativeStreamListOutputField,
    "NativeStreamListOutputType": NativeStreamListOutputType,
    "NativeStreamListTransformColumn": NativeStreamListTransformColumn,
    "NativeStreamMapKeyType": NativeStreamMapKeyType,
    "NativeStreamMapOutputField": NativeStreamMapOutputField,
    "NativeStreamMapOutputType": NativeStreamMapOutputType,
    "NativeStreamMapTransformColumn": NativeStreamMapTransformColumn,
    "NativeStreamOutputField": NativeStreamOutputField,
    "NativeStreamOutputType": NativeStreamOutputType,
    "NativeStreamProbeFilterReport": NativeStreamProbeFilterReport,
    "NativeStreamProbeIssue": NativeStreamProbeIssue,
    "NativeStreamProbeSamplingReport": NativeStreamProbeSamplingReport,
    "NativeStreamProfileSampleConfig": NativeStreamProfileSampleConfig,
    "NativeStreamProperties": NativeStreamProperties,
    "NativeStreamSamplingConfig": NativeStreamSamplingConfig,
    "NativeStreamSamplingFeature": NativeStreamSamplingFeature,
    "NativeStreamScalarOutputField": NativeStreamScalarOutputField,
    "NativeStreamScalarOutputType": NativeStreamScalarOutputType,
    "NativeStreamScalarTransformColumn": NativeStreamScalarTransformColumn,
    "NativeStreamSchemaColumn": NativeStreamSchemaColumn,
    "NativeStreamSchemaConfig": NativeStreamSchemaConfig,
    "NativeStreamSpoolConfig": NativeStreamSpoolConfig,
    "NativeStreamStatsConfig": NativeStreamStatsConfig,
    "NativeStreamStructOutputField": NativeStreamStructOutputField,
    "NativeStreamStructOutputType": NativeStreamStructOutputType,
    "NativeStreamStructTransformColumn": NativeStreamStructTransformColumn,
    "NativeStreamTransformColumn": NativeStreamTransformColumn,
    "NativeStreamTransformConfig": NativeStreamTransformConfig,
    "NativeStreamTransformProbeRequest": NativeStreamTransformProbeRequest,
    "NativeStreamTransformProbeResponse": NativeStreamTransformProbeResponse,
    "NativeStreamTransformUdf": NativeStreamTransformUdf,
    "NativeStreamUpsertConfig": NativeStreamUpsertConfig,
    "NativeStreamVariantShreddingConfig": NativeStreamVariantShreddingConfig,
    "Notebook": Notebook,
    "NotebookExecutionOutput": NotebookExecutionOutput,
    "NotebookExecutionResult": NotebookExecutionResult,
    "NotebookSession": NotebookSession,
    "NotificationMessageMapping": NotificationMessageMapping,
    "NumericDistribution": NumericDistribution,
    "OverrideParseResult": OverrideParseResult,
    "OverrideSampleExample": OverrideSampleExample,
    "PageResponseEnvelope": PageResponseEnvelope,
    "PaimonRestCatalogConfig": PaimonRestCatalogConfig,
    "PaimonSinkProperties": PaimonSinkProperties,
    "ParsedValue": ParsedValue,
    "PartitionCandidate": PartitionCandidate,
    "PartitionField": PartitionField,
    "PatchIngestionPipelineInput": PatchIngestionPipelineInput,
    "PathPartitionsTimestamp": PathPartitionsTimestamp,
    "PathSegment": PathSegment,
    "PipelineHistoryEntry": PipelineHistoryEntry,
    "PipelineHistoryField": PipelineHistoryField,
    "PipelineHistoryFieldChange": PipelineHistoryFieldChange,
    "PipelineHistoryKindFilters": PipelineHistoryKindFilters,
    "PipelineHistorySummary": PipelineHistorySummary,
    "PodObservation": PodObservation,
    "PollingConfig": PollingConfig,
    "ProbeError": ProbeError,
    "ProbeFailedResponse": ProbeFailedResponse,
    "ProbeFailedResponseError": ProbeFailedResponseError,
    "PscEndpoint": PscEndpoint,
    "PutDraftFileInput": PutDraftFileInput,
    "PutTableContextFileRequest": PutTableContextFileRequest,
    "PutTableContextFileResponse": PutTableContextFileResponse,
    "QuantilePoint": QuantilePoint,
    "QuantileTrendSeries": QuantileTrendSeries,
    "QuarantineBatch": QuarantineBatch,
    "QuarantineSampleRow": QuarantineSampleRow,
    "QuarantineSummary": QuarantineSummary,
    "RepositoryAsset": RepositoryAsset,
    "ResolvedRepositorySource": ResolvedRepositorySource,
    "RewriteTableContextResponse": RewriteTableContextResponse,
    "RunJobTemplateResponse": RunJobTemplateResponse,
    "S3DetectPartitionsRequest": S3DetectPartitionsRequest,
    "S3DetectPartitionsResponse": S3DetectPartitionsResponse,
    "S3FileSampleStats": S3FileSampleStats,
    "S3ListPrefixesRequest": S3ListPrefixesRequest,
    "S3ListPrefixesResponse": S3ListPrefixesResponse,
    "S3SampleFileRequest": S3SampleFileRequest,
    "S3SampleFileResponse": S3SampleFileResponse,
    "S3SampleObject": S3SampleObject,
    "S3SourceProperties": S3SourceProperties,
    "SamplingSimulationRequest": SamplingSimulationRequest,
    "SamplingSimulationResponse": SamplingSimulationResponse,
    "SamplingSimulationSegment": SamplingSimulationSegment,
    "SamplingSimulationSubset": SamplingSimulationSubset,
    "SaslSecretProbe": SaslSecretProbe,
    "SaveNotebookContentRequest": SaveNotebookContentRequest,
    "SavedQuery": SavedQuery,
    "SchemaChangeEvent": SchemaChangeEvent,
    "SchemaField": SchemaField,
    "SchemaReference": SchemaReference,
    "SchemaRegistryAuthConfig": SchemaRegistryAuthConfig,
    "SchemaRegistryAuthConfigInput": SchemaRegistryAuthConfigInput,
    "SchemaRegistryConfig": SchemaRegistryConfig,
    "SchemaRegistryConfigInput": SchemaRegistryConfigInput,
    "SchemaRegistryConnectRequest": SchemaRegistryConnectRequest,
    "SchemaRegistryConnectResponse": SchemaRegistryConnectResponse,
    "SchemaRegistryResolveSubjectRequest": SchemaRegistryResolveSubjectRequest,
    "SchemaRegistryResolveSubjectResponse": SchemaRegistryResolveSubjectResponse,
    "SchemaRegistrySchemaByIdRequest": SchemaRegistrySchemaByIdRequest,
    "SchemaRegistrySchemaRequest": SchemaRegistrySchemaRequest,
    "SchemaRegistrySchemaResponse": SchemaRegistrySchemaResponse,
    "SchemaRegistrySubject": SchemaRegistrySubject,
    "SchemaRegistrySubjectsRequest": SchemaRegistrySubjectsRequest,
    "SchemaRegistrySubjectsResponse": SchemaRegistrySubjectsResponse,
    "SecretRef": SecretRef,
    "SecretRefAws": SecretRefAws,
    "SecretRefGcp": SecretRefGcp,
    "SecretRefInput": SecretRefInput,
    "SecretRefInputAws": SecretRefInputAws,
    "SecretRefInputGcp": SecretRefInputGcp,
    "SecurityGroupRule": SecurityGroupRule,
    "SemanticLayerBuildResponse": SemanticLayerBuildResponse,
    "SendCommitterCommandRequest": SendCommitterCommandRequest,
    "SendCommitterCommandResponse": SendCommitterCommandResponse,
    "SortAggregationServingTokenBy": SortAggregationServingTokenBy,
    "SortColumnSpec": SortColumnSpec,
    "SortCredentialsProfileBy": SortCredentialsProfileBy,
    "SortDashboardBy": SortDashboardBy,
    "SortDataCatalogBy": SortDataCatalogBy,
    "SortGitRepositoryBy": SortGitRepositoryBy,
    "SortGraphBy": SortGraphBy,
    "SortIngestionPartitionBy": SortIngestionPartitionBy,
    "SortIngestionPipelineBy": SortIngestionPipelineBy,
    "SortIngestionPipelineDeadLetterBy": SortIngestionPipelineDeadLetterBy,
    "SortJobTemplateBy": SortJobTemplateBy,
    "SortMaintenanceRunBy": SortMaintenanceRunBy,
    "SortNotebookBy": SortNotebookBy,
    "SortPipelineHistoryBy": SortPipelineHistoryBy,
    "SortSavedQueryBy": SortSavedQueryBy,
    "SortSparkEngineBy": SortSparkEngineBy,
    "SortSparkJobBy": SortSparkJobBy,
    "SortSqlEngineBy": SortSqlEngineBy,
    "SortSqlQueryExecutionBy": SortSqlQueryExecutionBy,
    "SortWorkspaceBy": SortWorkspaceBy,
    "SortZeroEtlPolicyBy": SortZeroEtlPolicyBy,
    "SourceShardByPathPartition": SourceShardByPathPartition,
    "SparkEngine": SparkEngine,
    "SparkEngineStatusFilters": SparkEngineStatusFilters,
    "SparkJob": SparkJob,
    "SparkJobRequestedSource": SparkJobRequestedSource,
    "SparkJobResolvedSource": SparkJobResolvedSource,
    "SparkJobRetryPolicy": SparkJobRetryPolicy,
    "SparkJobSource": SparkJobSource,
    "SparkJobSourceInput": SparkJobSourceInput,
    "SparkJobSparkSubmitParams": SparkJobSparkSubmitParams,
    "SparkJobStatusFilters": SparkJobStatusFilters,
    "SparkJobStorageConfig": SparkJobStorageConfig,
    "SqlEngine": SqlEngine,
    "SqlEngineStatusFilters": SqlEngineStatusFilters,
    "SqlQueryExecution": SqlQueryExecution,
    "SqlQueryExecutionResult": SqlQueryExecutionResult,
    "SqlQueryExecutionResultColumn": SqlQueryExecutionResultColumn,
    "SqlQueryExecutionStatusFilters": SqlQueryExecutionStatusFilters,
    "SqsQueuePolicyProbeError": SqsQueuePolicyProbeError,
    "SqsQueuePolicyProbeRequest": SqsQueuePolicyProbeRequest,
    "SqsQueuePolicyProbeResponse": SqsQueuePolicyProbeResponse,
    "StartGitIntegrationAuthorizationInput": StartGitIntegrationAuthorizationInput,
    "StartGitIntegrationAuthorizationResponse": StartGitIntegrationAuthorizationResponse,
    "StartNotebookSessionInput": StartNotebookSessionInput,
    "StartSparkJobDirectParams": StartSparkJobDirectParams,
    "StartSparkJobDirectParamsSource": StartSparkJobDirectParamsSource,
    "StartSparkJobInput": StartSparkJobInput,
    "StartSparkJobTemplateParams": StartSparkJobTemplateParams,
    "StartSqlQueryExecutionInput": StartSqlQueryExecutionInput,
    "StatWidget": StatWidget,
    "StateListItem": StateListItem,
    "StateListWidget": StateListWidget,
    "StorageConfig": StorageConfig,
    "StreamCursorHalt": StreamCursorHalt,
    "StreamCursorResetRequest": StreamCursorResetRequest,
    "StringFilters": StringFilters,
    "SubjectResolution": SubjectResolution,
    "TableColumnProfile": TableColumnProfile,
    "TableColumnStats": TableColumnStats,
    "TableColumnTopValue": TableColumnTopValue,
    "TableContextColumn": TableContextColumn,
    "TableContextColumnEdit": TableContextColumnEdit,
    "TableContextDecidedColumn": TableContextDecidedColumn,
    "TableContextEdit": TableContextEdit,
    "TableContextFile": TableContextFile,
    "TableContextKind": TableContextKind,
    "TableContextKindColumn": TableContextKindColumn,
    "TableContextKindEdit": TableContextKindEdit,
    "TableContextKinds": TableContextKinds,
    "TableContextLeftOut": TableContextLeftOut,
    "TableContextMetric": TableContextMetric,
    "TableContextMetricEdit": TableContextMetricEdit,
    "TableContextNewNote": TableContextNewNote,
    "TableContextNote": TableContextNote,
    "TableContextNoteEdit": TableContextNoteEdit,
    "TableContextOverview": TableContextOverview,
    "TableContextRejectedMetric": TableContextRejectedMetric,
    "TableContextRelease": TableContextRelease,
    "TableContextRewrite": TableContextRewrite,
    "TableContextSameColumns": TableContextSameColumns,
    "TableContextSegment": TableContextSegment,
    "TableContextSegmentColumn": TableContextSegmentColumn,
    "TableContextSegmentMap": TableContextSegmentMap,
    "TableContextSegmentMapCell": TableContextSegmentMapCell,
    "TableContextSegmentMapRow": TableContextSegmentMapRow,
    "TableContextSegments": TableContextSegments,
    "TableContextSummary": TableContextSummary,
    "TableContextVersion": TableContextVersion,
    "TableDataQualityPartitionRow": TableDataQualityPartitionRow,
    "TableDataQualitySettings": TableDataQualitySettings,
    "TableEventTimeBucket": TableEventTimeBucket,
    "TableLiveView": TableLiveView,
    "TableMaintenanceConfig": TableMaintenanceConfig,
    "TableRetentionConfig": TableRetentionConfig,
    "TableSampleCell": TableSampleCell,
    "TableSignal": TableSignal,
    "TableSourceProperties": TableSourceProperties,
    "TableSourceStart": TableSourceStart,
    "TableWidget": TableWidget,
    "Threshold": Threshold,
    "ThresholdStep": ThresholdStep,
    "TimeseriesWidget": TimeseriesWidget,
    "TlsSecretProbe": TlsSecretProbe,
    "TriggeredAction": TriggeredAction,
    "UpdateAwsPrivateLinkInput": UpdateAwsPrivateLinkInput,
    "UpdateCredentialsProfileInput": UpdateCredentialsProfileInput,
    "UpdateCredentialsProfileInputAws": UpdateCredentialsProfileInputAws,
    "UpdateCredentialsProfileInputGcp": UpdateCredentialsProfileInputGcp,
    "UpdateDashboardInput": UpdateDashboardInput,
    "UpdateGraphInput": UpdateGraphInput,
    "UpdateIngestionPipelineInput": UpdateIngestionPipelineInput,
    "UpdateJobTemplateInput": UpdateJobTemplateInput,
    "UpdateMetricExportDestinationInput": UpdateMetricExportDestinationInput,
    "UpdateMetricExportDestinationInputSecretRef": UpdateMetricExportDestinationInputSecretRef,
    "UpdateNotebookInput": UpdateNotebookInput,
    "UpdatePscEndpointInput": UpdatePscEndpointInput,
    "UpdateSavedQueryInput": UpdateSavedQueryInput,
    "UpdateTableContextRequest": UpdateTableContextRequest,
    "UpdateTableContextResponse": UpdateTableContextResponse,
    "UpdateTableDataQualitySettingsRequest": UpdateTableDataQualitySettingsRequest,
    "UpdateTableMaintenanceConfigInput": UpdateTableMaintenanceConfigInput,
    "UpdateWorkspaceLoggingSettingsInput": UpdateWorkspaceLoggingSettingsInput,
    "UpdateWorkspaceLoggingSettingsInputAws": UpdateWorkspaceLoggingSettingsInputAws,
    "UpdateWorkspaceLoggingSettingsInputGcp": UpdateWorkspaceLoggingSettingsInputGcp,
    "UpdateWorkspaceMaintenanceSettingsRequest": UpdateWorkspaceMaintenanceSettingsRequest,
    "UpdateWorkspaceMetricsSettingsInput": UpdateWorkspaceMetricsSettingsInput,
    "UpdateWorkspaceMetricsSettingsInputAws": UpdateWorkspaceMetricsSettingsInputAws,
    "UpdateWorkspaceMetricsSettingsInputGcp": UpdateWorkspaceMetricsSettingsInputGcp,
    "UpdateWorkspaceStorageAccessConfigurationInput": UpdateWorkspaceStorageAccessConfigurationInput,
    "UpdateWorkspaceStorageAccessConfigurationInputAws": UpdateWorkspaceStorageAccessConfigurationInputAws,
    "UpdateWorkspaceStorageAccessConfigurationInputGcp": UpdateWorkspaceStorageAccessConfigurationInputGcp,
    "UpdateZeroEtlPolicyInput": UpdateZeroEtlPolicyInput,
    "ValueMapping": ValueMapping,
    "ValueMappingResult": ValueMappingResult,
    "WarmCapacity": WarmCapacity,
    "Widget": Widget,
    "WidgetLayout": WidgetLayout,
    "WidgetTableCell": WidgetTableCell,
    "WidgetTableColumn": WidgetTableColumn,
    "WidgetTableRow": WidgetTableRow,
    "Workspace": Workspace,
    "WorkspaceAllowedPrincipal": WorkspaceAllowedPrincipal,
    "WorkspaceAllowedPrincipalInput": WorkspaceAllowedPrincipalInput,
    "WorkspaceAws": WorkspaceAws,
    "WorkspaceAwsStorageAccessConfiguration": WorkspaceAwsStorageAccessConfiguration,
    "WorkspaceGcp": WorkspaceGcp,
    "WorkspaceGcpStorageAccessConfiguration": WorkspaceGcpStorageAccessConfiguration,
    "WorkspaceLoggingSettings": WorkspaceLoggingSettings,
    "WorkspaceLoggingSettingsAws": WorkspaceLoggingSettingsAws,
    "WorkspaceLoggingSettingsGcp": WorkspaceLoggingSettingsGcp,
    "WorkspaceMaintenanceSettings": WorkspaceMaintenanceSettings,
    "WorkspaceMetricsSettings": WorkspaceMetricsSettings,
    "WorkspaceMetricsSettingsAws": WorkspaceMetricsSettingsAws,
    "WorkspaceMetricsSettingsGcp": WorkspaceMetricsSettingsGcp,
    "WorkspaceNetworkingSettings": WorkspaceNetworkingSettings,
    "WorkspaceNetworkingSettingsAws": WorkspaceNetworkingSettingsAws,
    "WorkspaceNetworkingSettingsGcp": WorkspaceNetworkingSettingsGcp,
    "WorkspaceStatusFilters": WorkspaceStatusFilters,
    "WorkspaceStorageAccessConfiguration": WorkspaceStorageAccessConfiguration,
    "WorkspaceStorageAccessConfigurationAws": WorkspaceStorageAccessConfigurationAws,
    "WorkspaceStorageAccessConfigurationGcp": WorkspaceStorageAccessConfigurationGcp,
    "WorkspaceStorageAllowedCredentialsProfile": WorkspaceStorageAllowedCredentialsProfile,
    "WorkspaceStorageAllowedCredentialsProfileInput": WorkspaceStorageAllowedCredentialsProfileInput,
    "ZeroEtlIdentityColumnSpec": ZeroEtlIdentityColumnSpec,
    "ZeroEtlPolicy": ZeroEtlPolicy,
    "ZeroEtlResourceSelector": ZeroEtlResourceSelector,
    "ZeroEtlRoutingPolicy": ZeroEtlRoutingPolicy,
};
export class ObjectSerializer {
    static findCorrectType(data, expectedType) {
        if (data == undefined) {
            return expectedType;
        }
        else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        }
        else if (expectedType === "Date") {
            return expectedType;
        }
        else {
            if (enumsMap.has(expectedType)) {
                return expectedType;
            }
            if (!typeMap[expectedType]) {
                return expectedType;
            }
            let discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType;
            }
            else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    if (typeMap[discriminatorType]) {
                        return discriminatorType;
                    }
                    else {
                        return expectedType;
                    }
                }
                else {
                    return expectedType;
                }
            }
        }
    }
    static serialize(data, type, format) {
        if (data === undefined || data === null || primitives.includes(type.toLowerCase())) {
            return data;
        }
        else if (type.startsWith("Array<", 0)) {
            let subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.serialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type.startsWith("Set<", 0)) {
            let subType = type.replace("Set<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let item of data) {
                transformedData.push(ObjectSerializer.serialize(item, subType, format));
            }
            return transformedData;
        }
        else if (type === "Date") {
            if (format == "date") {
                let month = data.getMonth() + 1;
                month = month < 10 ? "0" + month.toString() : month.toString();
                let day = data.getDate();
                day = day < 10 ? "0" + day.toString() : day.toString();
                return data.getFullYear() + "-" + month + "-" + day;
            }
            else {
                return data.toISOString();
            }
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            type = this.findCorrectType(data, type);
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            let instance = {};
            for (let attributeType of attributeTypes) {
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
            }
            return instance;
        }
    }
    static deserialize(data, type, format) {
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        }
        else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        else if (type.lastIndexOf("Array<", 0) === 0) {
            let subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.deserialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type.lastIndexOf("Set<", 0) === 0) {
            let subType = type.replace("Set<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let item of data) {
                transformedData.push(ObjectSerializer.deserialize(item, subType, format));
            }
            return new Set(transformedData);
        }
        else if (type === "Date") {
            return new Date(data);
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            let instance = new typeMap[type]();
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            for (let attributeType of attributeTypes) {
                let value = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
                if (value !== undefined) {
                    instance[attributeType.name] = value;
                }
            }
            return instance;
        }
    }
    static getPreferredMediaType(mediaTypes) {
        return "application/json";
    }
}
